export const translations = {
  en: {
    translation: {
      // Common
      app_name: "SmartBalloon",
      save: "Save",
      cancel: "Cancel",
      delete: "Delete",
      edit: "Edit",
      close: "Close",
      confirm: "Confirm",
      loading: "Loading...",
      error: "Error",
      success: "Success",
      guide: "Guide",
      
      // Auth
      login: "Login",
      register: "Register",
      logout: "Logout",
      email: "Email",
      password: "Password",
      name: "Name",
      forgot_password: "Forgot password?",
      no_account: "Don't have an account?",
      have_account: "Already have an account?",
      login_success: "Login successful",
      register_success: "Registration successful",
      created_by_experience: "Created from the experience of",
      chat_bubble_message: "👋 Hi! I'm DenAIs, write me if you need help!",
      chat_welcome_message: "Hi, I'm DenAIs, your assistant. Write me if you need help!\n\n• How to use the app\n• Upload drawings\n• Create markers\n• AI features",
      denais_subtitle: "Your SmartBalloon assistant",
      
      // Navigation
      dashboard: "Dashboard",
      projects: "Projects",
      subscription: "Subscription",
      settings: "Settings",
      terms_of_use: "Terms of Use",
      
      // Projects
      new_project: "New Project",
      project_name: "Project Name",
      project_description: "Description",
      create_project: "Create Project",
      open_project: "Open",
      delete_project: "Delete Project",
      no_projects: "No projects yet. Create your first project!",
      
      // Workspace
      upload_drawing: "Upload Drawing",
      upload_logo: "Upload Logo",
      drop_file: "Drop file here or click to browse",
      supported_formats: "Supported: PDF, PNG, JPG",
      
      // Tools
      select_tool: "Select",
      select_move: "Select / Move",
      add_marker: "Add Marker",
      zoom_in: "Zoom In",
      zoom_out: "Zoom Out",
      fit_to_screen: "Fit to Screen",
      define_view: "Define View",
      detect_dimensions_ai: "Detect Dimensions AI",
      marker_ai: "Marker AI",
      select_marker_or_add_new: "Select a marker or add a new one",
      
      // How to use SmartBalloon dialog
      how_to_use_smartballoon: "How to use SmartBalloon",
      quick_guide_intro: "Here's a quick guide to get started",
      step_marker_ai: "Click on \"Marker AI\" in the toolbar, then click on the dimension in the drawing. The AI will automatically read the value and tolerances.",
      step_select_move: "Click on \"Select / Move\" to move already placed markers or to edit their data in the side panel.",
      step_select_move_tip: "Tip: Press DEL to delete the selected marker. Use UNDO to undo.",
      step_detect_ai_title: "Detect AI Dimensions (Recommended)",
      step_detect_ai_desc: "Click on \"Detect AI Dimensions\" to automatically analyze the entire drawing:",
      step_detect_ai_vector: "Vector PDF: Fast extraction + AI refinement",
      step_detect_ai_image: "Image/Scan: High-resolution multi-pass AI",
      step_detect_ai_tolerances: "General tolerances are automatically applied (ISO 2768)",
      step_detect_ai_correct: "You can correct/move markers after detection",
      step_export_title: "Export",
      step_export_desc: "When done, click \"Export PDF\" to get the ballooned drawing, or \"Export Excel\" for the ISIR report.",
      step_define_view_title: "Define View (Alternative)",
      step_define_view_desc: "For complex drawings or low-quality scans, use \"Define View\" to manually select the areas to analyze.",
      step_export_pdf: "PDF: Export the drawing with numbered balloons",
      step_export_excel: "Excel: Export the ISIR report with all data",
      got_it_lets_start: "Got it, let's start!",
      
      // Tutorial steps
      tutorial_upload_title: "Upload a drawing",
      tutorial_upload_desc: "Upload a technical drawing in PDF or image format to get started.",
      tutorial_add_balloon_title: "Add balloons",
      tutorial_add_balloon_desc: "Click on the drawing to add balloons manually, or use AI to automatically detect dimensions.",
      tutorial_edit_props_title: "Edit properties",
      tutorial_edit_props_desc: "Select a balloon to edit dimensions, tolerances and measuring instruments. The system automatically suggests instruments already used in the project!",
      tutorial_export_title: "Export results",
      tutorial_export_desc: "Generate the ballooned PDF or ISIR Excel report when done.",
      
      // Markers
      marker: "Marker",
      markers: "Markers",
      markers_click_expand: "Markers (click to expand)",
      description: "Description",
      nominal: "Nominal",
      tolerance_plus: "Tol +",
      tolerance_minus: "Tol -",
      measured_value: "Measured",
      instrument: "Instrument",
      resolution: "Resolution",
      result: "Result",
      ok: "OK",
      not_ok: "NOT OK",
      
      // AI
      ai_detect: "AI Detect Dimensions",
      ai_detecting: "Detecting...",
      ai_detection_failed: "AI detection failed",
      ai_premium_only: "AI detection is available with AI Premium plan",
      ai_suggestions: "AI Suggestions",
      accept_all: "Accept All",
      reject_all: "Reject All",
      not_vector_use_define_view: "Not vector - use \"Define View\" for better results",
      
      // CMM
      drag_cmm_report: "Drag CMM report",
      import_from_reports: "Import from {count} Reports",
      limit_reached: "Limit reached",
      
      // Title Block & Tolerances
      analyze_titleblock: "Analyze Title Block",
      general_tolerances: "GENERAL TOLERANCES",
      tolerances_auto_apply: "Tolerances will be automatically applied to dimensions without specific tolerances",
      
      // Views
      detected_views: "Detected Views",
      detecting_views: "Detecting views...",
      views_detected: "views detected",
      click_to_expand: "click to expand",
      scan_all: "Scan All",
      all_views_scanned: "All views scanned!",
      click_view_to_scan: "Click on a view in the drawing to scan it",
      
      // Export
      export: "Export",
      export_pdf: "Export PDF",
      export_excel: "Export ISIR Excel",
      exporting: "Exporting...",
      
      // Plans & Subscription Page
      free_plan: "Free",
      pro_plan: "Professional",
      ai_plan: "AI Premium",
      current_plan: "Current Plan",
      upgrade: "Upgrade",
      monthly: "month",
      features: "Features",
      max_markers: "markers maximum",
      unlimited_markers: "Unlimited markers",
      watermark: "Export with watermark",
      no_watermark: "Full export (no watermark)",
      ai_detection: "AI dimension detection",
      choose_your_plan: "Choose Your Plan",
      unlock_potential: "Unlock the full potential of SmartBalloon with our premium features",
      loading_plans: "Loading plans...",
      popular: "POPULAR",
      best_value: "BEST VALUE",
      your_plan: "YOUR PLAN",
      plus_vat: "+ VAT",
      ai_plan_desc: "AI View detection - 50 credits/month",
      ai_unlimited_desc: "Unlimited AI - scan all views without limits",
      markers_unlimited: "Unlimited markers",
      ai_view_detection: "AI View-Based detection",
      ai_credits_50: "50 AI credits/month (~12 views)",
      credits_per_view: "~4 credits per view scan",
      manual_clicks_free: "Manual AI clicks FREE",
      full_export: "Full PDF & Excel export",
      smartrevision_basic: "SmartRevision basic",
      everything_in_ai: "Everything included in AI",
      unlimited_ai_credits: "Unlimited AI credits",
      unlimited_view_scans: "Unlimited view scans",
      priority_support: "Priority support",
      smartrevision_unlimited: "SmartRevision unlimited",
      change_plan: "Change Plan",
      manage_subscription: "Manage Subscription",
      manage_subscription_desc: "Cancel, update payment, download invoices",
      
      // Trial System
      trial_plan: "7-Day AI Trial",
      trial_plan_short: "AI Trial",
      try_free_7_days: "Try free for 7 days",
      trial_description: "Full AI access for 7 days - no credit card required",
      trial_includes: "Trial includes",
      trial_smartballoon_limit: "1 SmartBalloon project with unlimited AI",
      trial_smartrevision_limit: "2 SmartRevision comparisons with full AI",
      trial_no_export: "PDF export requires subscription",
      trial_days_remaining: "days remaining",
      trial_day_remaining: "day remaining",
      trial_expires_today: "Trial expires today",
      trial_expired: "Trial Expired",
      trial_expired_title: "Your AI Trial has expired",
      trial_expired_message: "Upgrade to continue using SmartBalloon and SmartRevision with full AI features.",
      trial_project_limit_title: "Project Limit Reached",
      trial_project_limit_message: "Your AI Trial includes 1 project. Upgrade to create additional projects.",
      trial_comparison_limit_title: "Comparison Limit Reached", 
      trial_comparison_limit_message: "Your AI Trial includes 2 comparisons. Upgrade to create more comparisons.",
      trial_export_blocked_title: "Export Not Available",
      trial_export_blocked_message: "Would you like to export to PDF? Upgrade to a paid plan to unlock PDF and Excel exports.",
      upgrade_now: "Upgrade Now",
      view_plans: "View Plans",
      start_trial: "Start Free Trial",
      trial_active: "Trial Active",
      trial_badge: "TRIAL",
      
      // Subscription cancelled (but still active until period end)
      subscription_cancelled: "Subscription Cancelled",
      subscription_cancelled_banner: "Your subscription has been cancelled",
      subscription_access_until: "You will continue to have access until",
      subscription_days_remaining: "days remaining",
      subscription_day_remaining: "day remaining",
      subscription_expires_today: "Subscription expires today",
      subscription_reactivate: "Reactivate Subscription",
      subscription_cancelled_hint: "Your plan will downgrade to FREE after this date",
      
      // Messages
      project_created: "Project created",
      project_deleted: "Project deleted",
      changes_saved: "Changes saved",
      upload_success: "File uploaded",
      export_started: "Export started",
      marker_limit: "Marker limit reached. Upgrade to PRO for unlimited markers.",
      
      // Quality warnings
      quality_warning_title: "Warning: Reduced Quality",
      quality_warning_large_file: "The file is very large. Resolution has been reduced to allow upload.",
      quality_warning_large_image: "The image has been resized to allow upload.",
      quality_warning_ocr_note: "Automatic dimension reading may be less accurate. For best results, consider using a lower resolution PDF or enter values manually.",
      upload_error_too_large: "File too large",
      upload_error_timeout: "Upload timed out. The file may be too large.",
      
      // Welcome popup
      welcome_title: "Welcome to SmartBalloon!",
      welcome_subtitle: "You're all set! Here's how to get started:",
      welcome_step1_title: "Create a new project",
      welcome_step1_desc: "Click \"New Project\" to start fresh",
      welcome_step2_title: "Upload your drawing",
      welcome_step2_desc: "Load a PDF or image to balloon",
      welcome_step3_title: "Place your balloons",
      welcome_step3_desc: "Click on dimensions to add markers",
      welcome_button: "Got it, let's go!",
      
      // Hero Section (Login Page)
      hero_title: "Manage quality and technical drawings in seconds",
      hero_subtitle: "From balloon creation to AI-powered revision comparison",
      hero_step1: "Upload drawing",
      hero_step2: "Detect dimensions",
      hero_step3: "Compare revisions",
      
      // SmartBalloon Card
      smartballoon_title: "SmartBalloon",
      smartballoon_subtitle: "Create balloons, generate ISIR reports and manage quality control automatically",
      smartballoon_feature1: "Automatic AI balloons",
      smartballoon_feature2: "ISIR report generation",
      smartballoon_feature3: "Complete dimension management",
      
      // SmartRevision Card
      smartrevision_headline: "Don't just trust the title block.",
      smartrevision_subheadline: "Compare two revisions and discover every change in seconds",
      smartrevision_title: "SmartRevision",
      smartrevision_subtitle: "Analyze differences between drawings and prevent production errors",
      smartrevision_feature1: "Automatic difference detection",
      smartrevision_feature2: "Critical change highlighting",
      smartrevision_feature3: "Reduces production errors",
      
      hero_ai_premium: "Available with",
      
      // ComparePage - SmartRevision Workspace
      old_revision: "Old Revision",
      new_revision: "New Revision",
      all_comparisons: "All comparisons",
      export_pdf: "Export PDF",
      differences: "Differences",
      found: "found",
      vector: "Vector",
      opacity: "Opacity",
      start_smartrevision: "Start SmartRevision",
      legend: "Legend",
      legend_desc: "Differences are highlighted with colored circles/ellipses to keep original values readable.",
      removed: "Removed",
      added: "Added",
      modified: "Modified",
      removed_desc: "present in {oldRev}, absent in {newRev}",
      added_desc: "absent in {oldRev}, present in {newRev}",
      summary: "Summary:",
      differences_list: "Differences List",
      importance: "Importance:",
      importance_high: "high",
      importance_medium: "medium",
      importance_low: "low",
      visual_diffs_detected: "Visual differences detected. Semantic details not available.",
      upload_both_drawings: "Upload both drawings",
      then_click: "then click",
      green_added: "Green (Added)",
      red_removed: "Red (Removed)",
      yellow_modified: "Yellow (Modified)",
      diff_editor: "Differences Editor",
      add_note: "Add note",
      add_circle: "Add circle",
      undo: "Undo",
      save_changes: "Save changes",
      saved: "Saved",
      delete_circle: "Delete circle",
      editor_instructions_line1: "Click on circle/note to select • Drag to move • DEL to delete",
      editor_instructions_line2: "Drag corners to resize • Scroll to zoom • Ctrl+Z to undo",
      note_text_label: "Note text:",
      loading_high_res: "Loading high resolution image...",
      loading_high_res_desc: "This allows maximum quality for technical drawings",
      new_comparison_name: "New comparison",
      guided_comparison_title: "Need to compare only one or more views of the drawing?",
      guided_comparison_desc: "Use Guided View Comparison",
      guided_comparison_hint: "Use this mode when views have been moved between revisions",
      ai_credits_10: "Analysis costs 10 AI credits.",
      differences_found: "Differences found:",
      zero_differences_title: "No differences found",
      zero_differences_message: "The automatic comparison found 0 differences. Are you sure these are different versions of the same drawing?",
      zero_differences_hint: "If so, try using Guided View Comparison to manually select specific areas to compare.",
      try_guided_comparison: "Try Guided Comparison",
      tutorial_upload_old: "Upload old revision",
      tutorial_upload_old_desc: "Upload the drawing from the previous revision (PDF or image).",
      tutorial_upload_new: "Upload new revision",
      tutorial_upload_new_desc: "Upload the drawing from the new revision to compare.",
      tutorial_start_analysis: "Start analysis",
      tutorial_start_analysis_desc: "AI will automatically detect differences between the two revisions.",
      tutorial_open_editor: "Open editor",
      tutorial_open_editor_desc: "Check and edit difference markers in the fullscreen editor.",
      user_circle: "(user)",
      new_note: "New note",
      guided_results_title: "Guided Comparison Results",
      views_analyzed: "views analyzed",
      credits_consumed: "Credits consumed",
      no_differences: "No differences detected.",
      
      // Dashboard & Folders
      new_folder: "New Folder",
      folder_name: "Folder Name",
      folder_placeholder: "E.g: Clients 2026",
      create_folder: "Create Folder",
      rename_project: "Rename Project",
      move_to: "Move to",
      move_to_root: "Move to root",
      no_description: "No description",
      upload_logo: "Upload Logo",
      upload_company_logo: "Upload your company logo. It will be used in ISIR reports.",
      logo_uploaded: "Company logo uploaded!",
      logo_deleted: "Logo deleted",
      logo_only_images: "Only images are allowed",
      logo_too_large: "Logo too large. Maximum 500KB",
      folder_created: "Folder created",
      folder_deleted: "Folder deleted",
      project_renamed: "Project renamed",
      project_moved: "Project moved",
      confirm_delete_folder: "Delete this folder? Projects will be moved to root.",
      confirm_delete_project: "Are you sure you want to delete this project?",
      
      // SmartRevision Page
      smartrevision_page_title: "SmartRevision",
      smartrevision_page_subtitle: "Analyze differences between drawings",
      new_comparison: "New Comparison",
      comparison_name: "Comparison Name",
      comparison_description: "Description (optional)",
      create_comparison: "Create Comparison",
      no_comparisons: "No comparisons yet",
      no_comparisons_desc: "Create your first comparison to analyze drawing differences",
      upgrade_to_ai: "Upgrade to AI Plan",
      starting_from: "Starting from €99.99/month + VAT - 10 credits per analysis",
      features_included: "Features included:",
      visual_comparison: "Automatic visual comparison",
      semantic_analysis: "Semantic analysis with AI",
      pdf_export_report: "PDF export with detailed report",
      save_comparisons: "Save comparisons",
      credits_label: "Credits:",
      open_comparison: "Open",
      delete_comparison: "Delete",
      confirm_delete_comparison: "Are you sure you want to delete this comparison?",
      comparison_deleted: "Comparison deleted",
      comparison_created: "Comparison created",
      
      // SmartRevision Status & UI
      status_completed: "Completed",
      status_analyzing: "Analyzing...",
      status_failed: "Error",
      status_pending: "Pending",
      credits_used: "Credits used:",
      no_folder: "No folder",
      move_to_folder: "Move to folder",
      remove_from_folder: "Remove from folder",
      vs: "vs",
      
      // GuidePage
      back: "Back",
      guide_title: "SmartBalloon Guide",
      print_save_pdf: "Print / Save PDF",
      go_to_dashboard: "Go to Dashboard",
      table_of_contents: "TABLE OF CONTENTS",
      guide_intro: "Introduction",
      guide_upload: "1. Upload Drawing",
      guide_views: "2. Define Views",
      guide_ai_detection: "3. AI Detection",
      guide_markers: "4. Marker Management",
      guide_cmm: "5. CMM Import",
      guide_export: "6. Export",
      guide_smartrevision: "7. SmartRevision",
      guide_projects: "Project Management",
      guide_settings: "Settings",
      guide_faq: "FAQ",
      guide_welcome_title: "Welcome to SmartBalloon",
      guide_welcome_desc: "SmartBalloon is a professional tool for creating ballooned drawings and ISIR (Initial Sample Inspection Report) reports for industrial quality processes.",
      guide_step_upload: "Upload",
      guide_step_upload_desc: "Upload your technical PDF drawing",
      guide_step_detect: "Detect",
      guide_step_detect_desc: "AI automatically detects dimensions",
      guide_step_export: "Export",
      guide_step_export_desc: "Generate ballooned PDF and ISIR report",
      guide_tip_vector: "For best results, use vector PDFs generated directly from your CAD software (SolidWorks, AutoCAD, Inventor, etc.). Scanned PDFs may have less accurate results.",
      guide_features_title: "What you can do with SmartBalloon:",
      guide_feature_1: "Automatically detect dimensions from technical drawings using AI",
      guide_feature_2: "Create numbered markers (balloons) on dimensions",
      guide_feature_3: "Import data from CMM measurement machines",
      guide_feature_4: "Generate ISIR Excel reports with OK/NOK formulas",
      guide_feature_5: "Export ballooned drawings as PDF",
      guide_feature_6: "Organize projects in folders",
      guide_upload_title: "1. Drawing Upload",
      guide_upload_intro: "The first step is to upload the technical drawing you want to analyze.",
      guide_upload_step1_title: "Create a new project",
      guide_upload_step1_desc1: "From the Dashboard, click the \"New Project\" button.",
      guide_upload_step1_desc2: "Enter a descriptive name for the project (e.g., \"Motor Shaft REV.A\").",
      guide_upload_step2_title: "Upload the PDF drawing",
      guide_upload_step2_desc1: "In the left panel, you'll find the \"Upload Drawing\" area.",
      guide_upload_step2_desc2: "You can:",
      guide_upload_step2_opt1: "Drag the PDF file directly into the area",
      guide_upload_step2_opt2: "Click to open the file selector",
      guide_upload_step2_formats: "Supported formats: PDF, PNG, JPG",
      guide_upload_step3_title: "Wait for processing",
      guide_upload_step3_desc1: "The system will analyze the file and prepare it for viewing.",
      guide_upload_step3_desc2: "If the PDF is vector (generated from CAD), you'll see a green icon indicating you can use vector detection.",
      guide_upload_step3_tip: "For very large drawings (e.g., A0 format), the system automatically divides them into 'tiles' for better management.",
      guide_vector_vs_raster: "Vector vs Raster PDF: Vector PDFs allow more precise dimension detection because the text is already encoded in the file. Scanned PDFs (raster) require OCR and may be less accurate.",
      guide_views_title: "2. Defining Views",
      guide_views_intro: "Views are rectangular areas of the drawing that will be analyzed by AI to detect dimensions.",
      guide_views_step1_title: "Activate the View tool",
      guide_views_step1_desc1: "In the left panel, click on \"View\" in the Tools section.",
      guide_views_step1_desc2: "The cursor will change to a crosshair.",
      guide_views_step2_title: "Draw the view area",
      guide_views_step2_desc1: "Click and drag on the drawing to define the rectangular area.",
      guide_views_step2_desc2: "Try to include only the dimensions you want to detect, avoiding borders and title blocks.",
      guide_views_step2_tip: "Create smaller, focused views for better results. Avoid including too many dimensions in a single view.",
      guide_views_step3_title: "Repeat for other areas",
      guide_views_step3_desc1: "You can create multiple views to cover different areas of the drawing.",
      guide_views_step3_desc2: "Each view will be analyzed separately.",
      guide_views_credits_warning: "Important: Each view consumes approximately 2 AI credits when analyzed. If you have a plan with limited credits, plan your views carefully.",
      guide_ai_title: "3. AI Dimension Detection",
      guide_ai_intro: "SmartBalloon uses artificial intelligence to automatically detect dimensions from the drawing.",
      guide_ai_methods_title: "Detection Methods:",
      guide_ai_vector_title: "Vector Detection (Recommended)",
      guide_ai_vector_desc: "For vector PDFs. Extracts dimensions directly from the PDF file, then uses AI to refine results.",
      guide_ai_vector_cost: "Cost: 2-3 credits | Accuracy: High",
      guide_ai_vector_how: "How to use: Click the \"AI Detect Dimensions\" button in the right panel.",
      guide_ai_views_title: "View-Based Detection",
      guide_ai_views_desc: "Analyzes the views you've defined using artificial intelligence.",
      guide_ai_views_cost: "Cost: ~2 credits per view | Accuracy: Good",
      guide_ai_views_how: "How to use: After creating views, click \"Analyze this View\" on each view.",
      guide_ai_manual_title: "Manual Click (Free)",
      guide_ai_manual_desc: "Click directly on a dimension to have AI read it.",
      guide_ai_manual_cost: "Cost: Free | Accuracy: Very high",
      guide_ai_manual_how: "How to use: Activate the \"Marker\" tool and click on a dimension.",
      guide_ai_review_title: "Review suggestions",
      guide_ai_review_desc1: "AI suggestions will appear in the \"AI Suggestions\" panel.",
      guide_ai_review_desc2: "For each suggestion you can:",
      guide_ai_review_accept: "Accept: Accept and create the marker",
      guide_ai_review_modify: "Modify: Edit values before accepting",
      guide_ai_review_reject: "Reject: Discard the suggestion",
      guide_ai_review_tip: "You can modify values before accepting them by clicking 'Modify' on each suggestion.",
      guide_markers_title: "4. Marker Management",
      guide_markers_intro: "Markers (or balloons) are the circled numbers that identify each dimension on the drawing.",
      guide_markers_step1_title: "View markers",
      guide_markers_step1_desc1: "Accepted markers appear as numbered circles on the drawing.",
      guide_markers_step1_desc2: "Click on a marker to select it and see its details in the \"Properties\" panel.",
      guide_markers_step2_title: "Edit a marker",
      guide_markers_step2_desc: "With a marker selected, in the Properties panel you can modify:",
      guide_markers_field_number: "Number: The balloon number (e.g., 173, 184...)",
      guide_markers_field_nominal: "Nominal: The dimension value",
      guide_markers_field_tolerance: "Tolerances: Tol+ and Tol-",
      guide_markers_field_description: "Description: Descriptive text for the dimension",
      guide_markers_step3_title: "Move a marker",
      guide_markers_step3_desc1: "Drag a marker to move it to a better position on the drawing.",
      guide_markers_step3_desc2: "This is useful if AI placed the marker in a less visible spot.",
      guide_markers_step3_tip: "Marker numbers are persistent: you can assign any number and it will remain even after closing and reopening the project.",
      guide_markers_step4_title: "Delete a marker",
      guide_markers_step4_desc1: "Select the marker and click the trash icon in the Properties panel.",
      guide_markers_step4_desc2: "Or use the \"Delete\" button with the marker selected.",
      guide_markers_numbering_info: "Custom numbering: You can assign any number to markers. If you delete a marker, others will keep their original numbers.",
      guide_cmm_title: "5. CMM Data Import",
      guide_cmm_intro: "You can import measured values directly from your measurement machines (CMM) by uploading up to 5 PDF reports per project.",
      guide_cmm_new_feature: "New: You can now upload up to 5 CMM reports per project. The system automatically detects duplicate dimensions and asks which value to keep.",
      guide_cmm_step1_title: "Prepare CMM reports",
      guide_cmm_step1_desc: "CMM reports must be in PDF format and contain SB identifiers for each dimension:",
      guide_cmm_step1_format: "Format: SB + marker number (e.g., SB131, sb45). Case doesn't matter.",
      guide_cmm_step2_title: "Upload reports",
      guide_cmm_step2_desc1: "In the Upload panel on the right, you'll find the \"CMM Report (PDF) - Max 5\" section.",
      guide_cmm_step2_desc2: "Drag one or more PDF files into the area",
      guide_cmm_step2_desc3: "Or click to open the file selector",
      guide_cmm_step2_desc4: "You can upload up to 5 reports per project",
      guide_cmm_step2_note: "Uploaded reports appear in a list with the option to delete them individually.",
      guide_cmm_step3_title: "Import measurements",
      guide_cmm_step3_desc: "Click \"Import from X Reports\" to start the analysis.",
      guide_cmm_step3_process1: "Extracts all SB values from uploaded PDFs",
      guide_cmm_step3_process2: "Detects any duplicate dimensions",
      guide_cmm_step3_process3: "Shows a preview before importing",
      guide_cmm_step3_tip: "If the same SB number appears in multiple reports (e.g., SB45 in Report_Lot1.pdf and Report_Lot2.pdf), the system will ask which value to keep.",
      guide_cmm_step4_title: "Resolve duplicate dimensions",
      guide_cmm_step4_desc: "If duplicate dimensions are found, a dialog will appear for each duplicate:",
      guide_cmm_step4_action: "Select which value to keep for each duplicate dimension.",
      guide_cmm_step5_title: "Confirm import",
      guide_cmm_step5_desc: "After resolving any duplicates, you'll see the final preview.",
      guide_cmm_step5_check: "Check the dimensions you want to import",
      guide_cmm_step5_apply: "Click \"Apply Selected Measurements\"",
      guide_cmm_step5_result: "Measured values will be associated with corresponding markers.",
      guide_cmm_oknok_info: "OK/NOK Formulas: Once measured values are imported, the ISIR Excel export will automatically calculate whether each dimension is OK (within tolerance) or NOK (out of tolerance).",
      guide_cmm_summary_title: "CMM feature summary:",
      guide_cmm_summary_1: "Up to 5 PDF reports per project",
      guide_cmm_summary_2: "Automatic detection of SB + number identifiers",
      guide_cmm_summary_3: "Duplicate dimension management with value selection",
      guide_cmm_summary_4: "Source file indication for each value",
      guide_cmm_summary_5: "Preview and selection before import",
      guide_export_title: "6. Document Export",
      guide_export_intro: "SmartBalloon allows you to export results in different formats.",
      guide_export_pdf_title: "Ballooned PDF",
      guide_export_pdf_desc: "Generates a PDF with the original drawing and all markers (balloons) overlaid. Ideal for production documentation.",
      guide_export_pdf_how: "How: Export Panel → \"PDF\"",
      guide_export_excel_title: "ISIR Excel Report",
      guide_export_excel_desc: "Generates an Excel report with all dimensions, tolerances, measured values, and automatic OK/NOK formulas.",
      guide_export_excel_how: "How: Export Panel → \"Excel\"",
      guide_export_excel_features_title: "Excel ISIR Features:",
      guide_export_excel_feature_1: "Company logo in the top right (upload it from the Dashboard)",
      guide_export_excel_feature_2: "Project information (name, description, general tolerances)",
      guide_export_excel_feature_3: "Table with all dimensions and values",
      guide_export_excel_feature_4: "Automatic OK/NOK formulas based on tolerances",
      guide_export_excel_feature_5: "Header repeated on every printed page",
      guide_export_excel_feature_6: "Automatic page number (\"Page X of Y\")",
      guide_export_logo_info: "Company Logo: To include your company logo in reports, go to the Dashboard and click \"Upload Logo\" before exporting.",
      guide_smartrevision_title: "7. SmartRevision",
      guide_smartrevision_subtitle: "(analyze differences between drawings)",
      guide_smartrevision_intro: "SmartRevision allows you to compare two revisions of a technical drawing and automatically identify all differences.",
      guide_smartrevision_nav_info: "Navigation: You can access SmartRevision from the top navigation by clicking the \"SmartRevision\" tab next to \"SmartBalloon\".",
      guide_smartrevision_credits_warning: "AI Credits: Each SmartRevision analysis costs 10 AI credits. Available for AI and AI Unlimited plans.",
      guide_smartrevision_step1_title: "Create a new comparison",
      guide_smartrevision_step1_desc1: "From the top navigation, go to SmartRevision.",
      guide_smartrevision_step1_desc2: "Click \"New Comparison\" and assign a descriptive name (e.g., \"Part XYZ - Rev A vs Rev B\").",
      guide_smartrevision_step2_title: "Upload drawings",
      guide_smartrevision_step2_desc: "On the comparison page, upload:",
      guide_smartrevision_step2_old: "Old Revision: The previous revision (PDF or image)",
      guide_smartrevision_step2_new: "New Revision: The new revision (PDF or image)",
      guide_smartrevision_step2_vector: "The system will automatically detect if the PDF is vector.",
      guide_smartrevision_step2_rename: "Rename: Click on \"Old Revision\" or \"New Revision\" names to assign custom names.",
      guide_smartrevision_step3_title: "Start SmartRevision",
      guide_smartrevision_step3_desc: "Click \"Start SmartRevision\". The system:",
      guide_smartrevision_step3_process1: "Automatically aligns the two drawings",
      guide_smartrevision_step3_process2: "Detects visual differences with OpenCV (smart clustering)",
      guide_smartrevision_step3_process3: "Semantically analyzes changes with artificial intelligence",
      guide_smartrevision_step3_tip: "Analysis may take 30-60 seconds for complex drawings. A loading banner will keep you informed.",
      guide_smartrevision_step4_title: "Analyze results",
      guide_smartrevision_step4_desc: "Results show circles/ellipses highlighting modified areas:",
      guide_smartrevision_color_red: "Red: Elements removed (present in A, absent in B)",
      guide_smartrevision_color_green: "Green: Elements added (absent in A, present in B)",
      guide_smartrevision_color_yellow: "Yellow: Modified elements (different values)",
      guide_smartrevision_overlay_note: "The overlay uses circles/ellipses with outlines to not obscure the text underneath.",
      guide_smartrevision_step4_1_title: "Fullscreen Editor (optional)",
      guide_smartrevision_step4_1_desc: "Click the \"Differences\" card to open the fullscreen editor.",
      guide_smartrevision_step4_1_tip: "The fullscreen editor allows you to visually compare A and B precisely and edit markers.",
      guide_smartrevision_editor_features: "Available features:",
      guide_smartrevision_editor_slider: "Old↔New Slider: Adjust opacity to gradually transition from Old to New Revision",
      guide_smartrevision_editor_zoom: "Zoom: Use +/- buttons or mouse wheel (zoom centered on cursor)",
      guide_smartrevision_editor_pan: "Pan: Drag the background to move around",
      guide_smartrevision_editor_select: "Select marker: Click a marker to select it (4 white squares appear at corners)",
      guide_smartrevision_editor_move: "Move marker: Drag a selected marker to reposition it",
      guide_smartrevision_editor_resize: "Resize marker: Drag one of the 4 white corner squares to change size",
      guide_smartrevision_editor_delete: "Delete marker: Press DEL or use \"Delete circle\" button",
      guide_smartrevision_editor_add: "Add circle: Click \"Add circle\" and select color (Green=Added, Red=Removed, Yellow=Modified)",
      guide_smartrevision_editor_note: "Add note: Click \"Add note\" to insert a text box",
      guide_smartrevision_editor_edit_note: "Edit note: Select a note and edit text in the field at top left",
      guide_smartrevision_editor_resize_note: "Resize note: Drag white squares at note corners",
      guide_smartrevision_editor_undo: "Undo: Ctrl+Z or \"Undo\" button (last 20 actions)",
      guide_smartrevision_editor_save: "Save changes: Click \"Save changes\" (green) to save corrections to database",
      guide_smartrevision_editor_important: "Important: Changes to markers and notes are only saved by pressing \"Save changes\". PDF export will always include current editor changes, including text notes.",
      guide_smartrevision_user_circles: "Note: User-added circles are displayed with dashed lines and the letter \"U\" above. In the exported PDF, the \"Operator Changes\" section lists all manual changes (added, deleted, or repositioned circles).",
      guide_smartrevision_step5_title: "Export PDF report",
      guide_smartrevision_step5_desc: "Click \"Export PDF\" to generate a document with:",
      guide_smartrevision_step5_page1: "Page 1: Differences overlay (original Old Revision dimensions)",
      guide_smartrevision_step5_page2: "Page 2+: Color legend and semantic differences list",
      guide_smartrevision_format_preserved: "Format preserved: The PDF output always maintains the dimensions and format of the Old Revision (e.g., horizontal A0, A3, etc.). Notes are on separate A4 pages for readability.",
      guide_smartrevision_use_cases_title: "Common use cases:",
      guide_smartrevision_use_case_1: "Compare revisions of the same part number (Rev A vs Rev B)",
      guide_smartrevision_use_case_2: "Compare product variants (similar codes with small differences)",
      guide_smartrevision_use_case_3: "Verify customer-requested changes",
      guide_smartrevision_use_case_4: "Audit trail of design changes",
      guide_smartrevision_use_case_5: "Pre-production quality control",
      guide_smartrevision_advanced_title: "Advanced features:",
      guide_smartrevision_advanced_1: "Smart clustering: Nearby differences are automatically grouped",
      guide_smartrevision_advanced_2: "Geometric line filter: Thin lines are filtered to highlight only significant changes",
      guide_smartrevision_advanced_3: "Opacity control: Adjust overlay opacity to better see the drawing underneath",
      guide_smartrevision_advanced_4: "Rename drawings: Customize \"Old Revision\" and \"New Revision\" names by clicking on them",
      guide_smartrevision_advanced_5: "Fullscreen editor: Visually compare A vs B and edit markers directly",
      guide_smartrevision_advanced_6: "Resize markers: Drag white squares to adjust circle sizes",
      guide_smartrevision_advanced_7: "Custom circles: Add green/red/yellow circles to flag changes not automatically detected",
      guide_smartrevision_advanced_8: "Text notes: Add text annotations on the drawing, resizable and saveable",
      guide_smartrevision_advanced_9: "Change tracking: Exported PDF shows \"Removed by user\", \"Added by user\", etc.",
      guide_smartrevision_advanced_10: "Save changes: Persist manual corrections to database before exporting",
      guide_smartrevision_advanced_11: "Export directly: You can export PDF from both main page and fullscreen editor",
      guide_smartrevision_guided_title: "ADVANCED",
      guide_smartrevision_guided_subtitle: "Guided View Comparison",
      guide_smartrevision_guided_desc: "For drawings with modified layout between revisions (e.g., moved views, repositioned sections).",
      guide_smartrevision_guided_when_title: "When to use it:",
      guide_smartrevision_guided_when_1: "Views that have been moved to different positions",
      guide_smartrevision_guided_when_2: "Sections repositioned within the drawing",
      guide_smartrevision_guided_when_3: "Complex comparisons with completely redesigned layout",
      guide_smartrevision_guided_when_4: "When automatic analysis can't align views",
      guide_smartrevision_guided_how_title: "How it works:",
      guide_smartrevision_guided_how_1: "Click \"Add view\" in the Guided Comparison section",
      guide_smartrevision_guided_how_2: "Draw a rectangle on the old revision (area to compare)",
      guide_smartrevision_guided_how_3: "Draw the corresponding rectangle on the new revision",
      guide_smartrevision_guided_how_4: "Repeat for each view to compare",
      guide_smartrevision_guided_how_5: "Click \"Start Guided Comparison\"",
      guide_smartrevision_guided_cost: "Cost: 2 AI credits per compared view",
      guide_smartrevision_popup_warning: "Popups blocked? If the PDF doesn't open, check that your browser allows popups for this site. A warning will remind you to check this setting before exporting.",
      guide_projects_title: "Project Management",
      guide_projects_intro: "Organize your projects efficiently using folders and management functions.",
      guide_projects_folders_title: "Folders",
      guide_projects_folder_step1_title: "Create a folder",
      guide_projects_folder_step1_desc1: "In the Dashboard, click \"New Folder\".",
      guide_projects_folder_step1_desc2: "Assign a name and color to identify it easily.",
      guide_projects_folder_step2_title: "Move projects to folders",
      guide_projects_folder_step2_desc1: "Click the three dots on a project card.",
      guide_projects_folder_step2_desc2: "Select \"Move to\" and choose the destination folder.",
      guide_projects_actions_title: "Project Actions",
      guide_projects_action_rename: "Rename",
      guide_projects_action_rename_how: "Three-dot menu → Rename",
      guide_projects_action_move: "Move",
      guide_projects_action_move_how: "Three-dot menu → Move to",
      guide_projects_action_delete: "Delete",
      guide_projects_action_delete_how: "Three-dot menu → Delete",
      guide_settings_title: "Settings and Configuration",
      guide_settings_logo_title: "Company Logo",
      guide_settings_logo_desc: "From the Dashboard, click \"Upload Logo\" to upload your company logo. This logo will appear in exported ISIR reports.",
      guide_settings_logo_formats: "Supported formats: PNG, JPG, SVG",
      guide_settings_logo_size: "Maximum size: 500KB",
      guide_settings_tolerance_title: "ISO 2768 General Tolerances",
      guide_settings_tolerance_desc: "If your drawing specifies ISO 2768 general tolerances, SmartBalloon can apply them automatically. When it detects dimensions without specified tolerances, it will ask which class to apply (mK, fK, cK, vK).",
      guide_settings_api_title: "OpenAI API Key",
      guide_settings_api_desc: "If you want to use your own OpenAI API key instead of the credits included in your plan, you can configure it in your profile settings.",
      guide_faq_title: "Frequently Asked Questions (FAQ)",
      guide_faq_q1: "How many AI credits do I have?",
      guide_faq_a1: "It depends on your plan. The AI plan includes 50 credits/month, the AI Unlimited plan has unlimited credits. You can see remaining credits in the Dashboard.",
      guide_faq_q2: "Is manual click on dimensions free?",
      guide_faq_a2: "Yes! Manual click to read single dimensions doesn't consume AI credits.",
      guide_faq_q3: "How do I know if my PDF is vector?",
      guide_faq_a3: "After uploading the PDF, you'll see a green 'Vector' icon if the PDF is vector. PDFs generated from CAD are almost always vector.",
      guide_faq_q4: "Do marker numbers change when I delete one?",
      guide_faq_a4: "No, marker numbers are persistent. If you delete marker 5, markers 4 and 6 will keep their numbers.",
      guide_faq_q5: "Can I use SmartBalloon offline?",
      guide_faq_a5: "No, SmartBalloon requires an internet connection for AI functionality and project saving.",
      guide_faq_q6: "How can I contact support?",
      guide_faq_a6: "You can use the DenAIs chatbot (icon at bottom right) or write to info@lscsrl.it",
      guide_faq_q7: "Are my drawings secure?",
      guide_faq_a7: "Yes, your data is encrypted and stored securely. See our Privacy Policy for more details.",
      guide_suggestion: "Suggestion:",
      
      // CMM Import Modal
      cmm_interpret_title: "How to interpret reports?",
      cmm_interpret_desc: "You have uploaded <strong>{count} CMM reports</strong>. How should they be interpreted?",
      cmm_mode_manual_title: "I assign pieces manually",
      cmm_mode_manual_desc: "<strong>You choose</strong> which report corresponds to which piece/sample.",
      cmm_mode_manual_hint: "You can rename pieces (e.g., \"Piece A\", \"Lot 123\", etc.)",
      cmm_mode_multi_title: "Multiple samples (automatic)",
      cmm_mode_multi_desc: "Each report is a <strong>different piece/sample</strong>, automatic numbering.",
      cmm_mode_multi_hint: "Report 1 → P1, Report 2 → P2, etc.",
      cmm_mode_duplicate_title: "Duplicate reports",
      cmm_mode_duplicate_desc: "Reports contain <strong>measurements of the same piece</strong>.",
      cmm_mode_duplicate_hint: "Duplicate dimensions will be flagged for manual selection.",
      cmm_continue: "Continue",
      cmm_assign_title: "Assign Reports to Pieces",
      cmm_assign_desc: "Assign a name/number to each report. This will identify the piece in ISIR Excel columns.",
      cmm_assign_placeholder: "E.g.: P1, Piece A, Lot 123",
      cmm_assign_tip: "Use short names that will appear as column headers in Excel (e.g., P1, P2, Lot A, etc.)",
      cmm_continue_import: "Continue with Import",
      cmm_duplicate_title: "Duplicate Dimension - SB{id}",
      cmm_duplicate_desc: "This dimension is present in multiple reports. Select which value to keep.",
      cmm_duplicate_count: "({current} of {total} duplicates)",
      cmm_duplicate_existing: "Existing marker:",
      cmm_duplicate_current: "(current: {value})",
      cmm_duplicate_prev: "← Back",
      cmm_duplicate_next: "Next →",
      cmm_duplicate_confirm_all: "Confirm All",
      
      // Manual Marker
      manual_marker: "Manual Marker",
      manual_marker_desc: "For dimensions that AI can't read (rotated, blurry), use \"Manual Marker\".",
      manual_marker_warning: "Also use Manual Marker for geometric tolerances (flatness ⌂, parallelism //, cylindricity ○, etc.)",
      manual_marker_insert: "Manual Marker Insert",
    }
  },
  it: {
    translation: {
      // Common
      app_name: "SmartBalloon",
      save: "Salva",
      cancel: "Annulla",
      delete: "Elimina",
      edit: "Modifica",
      close: "Chiudi",
      confirm: "Conferma",
      loading: "Caricamento...",
      error: "Errore",
      success: "Successo",
      guide: "Guida",
      
      // Auth
      login: "Accedi",
      register: "Registrati",
      logout: "Esci",
      email: "Email",
      password: "Password",
      name: "Nome",
      forgot_password: "Password dimenticata?",
      no_account: "Non hai un account?",
      have_account: "Hai già un account?",
      login_success: "Accesso effettuato",
      register_success: "Registrazione completata",
      created_by_experience: "Creato dall'esperienza di",
      chat_bubble_message: "👋 Ciao! Sono DenAIs, scrivimi se hai bisogno!",
      chat_welcome_message: "Ciao, sono DenAIs, il tuo assistente. Scrivimi se hai bisogno!\n\n• Come usare l'app\n• Caricamento disegni\n• Creazione marker\n• Funzioni AI",
      denais_subtitle: "Il tuo assistente SmartBalloon",
      
      // Navigation
      dashboard: "Dashboard",
      projects: "Progetti",
      subscription: "Abbonamento",
      settings: "Impostazioni",
      terms_of_use: "Condizioni di Utilizzo",
      
      // Projects
      new_project: "Nuovo Progetto",
      project_name: "Nome Progetto",
      project_description: "Descrizione",
      create_project: "Crea Progetto",
      open_project: "Apri",
      delete_project: "Elimina Progetto",
      no_projects: "Nessun progetto. Crea il tuo primo progetto!",
      
      // Workspace
      upload_drawing: "Carica Disegno",
      upload_logo: "Carica logo azienda da inserire nell'ISIR",
      drop_file: "Trascina il file qui o clicca per sfogliare",
      supported_formats: "Supportati: PDF, PNG, JPG",
      
      // Tools
      select_tool: "Seleziona",
      select_move: "Selezione / Sposta",
      add_marker: "Aggiungi Marcatore",
      zoom_in: "Ingrandisci",
      zoom_out: "Riduci",
      fit_to_screen: "Adatta allo Schermo",
      define_view: "Definisci Vista",
      detect_dimensions_ai: "Rileva Quote AI",
      marker_ai: "Marker AI",
      select_marker_or_add_new: "Seleziona un marker o aggiungine uno nuovo",
      
      // How to use SmartBalloon dialog
      how_to_use_smartballoon: "Come usare SmartBalloon",
      quick_guide_intro: "Ecco una guida rapida per iniziare",
      step_marker_ai: "Clicca su \"Marker AI\" nella toolbar, poi clicca sulla quota nel disegno. L'AI leggerà automaticamente il valore e le tolleranze.",
      step_select_move: "Clicca su \"Seleziona / Sposta\" per spostare i marker già posizionati o per modificare i loro dati nel pannello laterale.",
      step_select_move_tip: "Tip: Premi CANC per eliminare il marker selezionato. Usa UNDO per annullare.",
      step_detect_ai_title: "Rileva Quote AI (Consigliato)",
      step_detect_ai_desc: "Clicca su \"Rileva Quote AI\" per analizzare automaticamente l'intero disegno:",
      step_detect_ai_vector: "PDF Vettoriale: Estrazione veloce + raffinamento AI",
      step_detect_ai_image: "Immagine/Scansione: Multi-pass AI ad alta risoluzione",
      step_detect_ai_tolerances: "Le tolleranze generiche vengono applicate automaticamente (ISO 2768)",
      step_detect_ai_correct: "Puoi correggere/spostare i marker dopo il rilevamento",
      step_export_title: "Esporta",
      step_export_desc: "Quando hai finito, clicca \"Esporta PDF\" per ottenere il disegno con i balloon, oppure \"Esporta Excel\" per il report ISIR.",
      step_define_view_title: "Definisci Vista (Alternativa)",
      step_define_view_desc: "Per disegni complessi o scansioni di bassa qualità, usa \"Definisci Vista\" per selezionare manualmente le aree da analizzare.",
      step_export_pdf: "PDF: Esporta il disegno con i pallini numerati",
      step_export_excel: "Excel: Esporta il report ISIR con tutti i dati",
      got_it_lets_start: "Ho capito, iniziamo!",
      
      // Tutorial steps
      tutorial_upload_title: "Carica un disegno",
      tutorial_upload_desc: "Carica un disegno tecnico in formato PDF o immagine per iniziare.",
      tutorial_add_balloon_title: "Aggiungi balloon",
      tutorial_add_balloon_desc: "Clicca sul disegno per aggiungere balloon manualmente, oppure usa l'AI per rilevare automaticamente le quote.",
      tutorial_edit_props_title: "Modifica proprietà",
      tutorial_edit_props_desc: "Seleziona un balloon per modificare quote, tolleranze e strumenti di misura. Il sistema suggerisce automaticamente gli strumenti già utilizzati nel progetto!",
      tutorial_export_title: "Esporta i risultati",
      tutorial_export_desc: "Genera il PDF ballonato o il report Excel ISIR quando hai finito.",
      
      // Markers
      marker: "Marcatore",
      markers: "Marcatori",
      markers_click_expand: "Markers (clicca per espandere)",
      description: "Quota a disegno",
      nominal: "Specifica nominale",
      tolerance_plus: "Toll. sup",
      tolerance_minus: "Toll. inf",
      measured_value: "Valore misurato",
      instrument: "Strumento",
      resolution: "Risoluzione",
      result: "Esito",
      ok: "OK",
      not_ok: "NON OK",
      
      // AI
      ai_detect: "Rileva Dimensioni AI",
      ai_detecting: "Rilevamento...",
      ai_detection_failed: "Rilevamento AI fallito",
      ai_premium_only: "Il rilevamento AI è disponibile con il piano AI Premium",
      ai_suggestions: "Suggerimenti AI",
      accept_all: "Accetta Tutti",
      reject_all: "Rifiuta Tutti",
      not_vector_use_define_view: "Non vettoriale - usa \"Definisci Vista\" per migliori risultati",
      
      // CMM
      drag_cmm_report: "Trascina report CMM",
      import_from_reports: "Importa da {count} Report",
      limit_reached: "Limite raggiunto",
      
      // Title Block & Tolerances
      analyze_titleblock: "Analizza Cartiglio",
      general_tolerances: "TOLLERANZE GENERALI",
      tolerances_auto_apply: "Le tolleranze verranno applicate automaticamente alle quote senza tolleranze specifiche",
      
      // Views
      detected_views: "Viste Rilevate",
      detecting_views: "Rilevamento viste...",
      views_detected: "viste rilevate",
      click_to_expand: "clicca per espandere",
      scan_all: "Scansiona Tutte",
      all_views_scanned: "Tutte le viste scansionate!",
      click_view_to_scan: "Clicca su una vista nel disegno per scansionarla",
      
      // Export
      export: "Esporta",
      export_pdf: "Esporta PDF",
      export_excel: "Esporta ISIR Excel",
      exporting: "Esportazione...",
      
      // Plans & Subscription Page
      free_plan: "Gratuito",
      pro_plan: "Professionale",
      ai_plan: "AI Premium",
      current_plan: "Piano Attuale",
      upgrade: "Aggiorna",
      monthly: "mese",
      features: "Funzionalità",
      max_markers: "marcatori massimo",
      unlimited_markers: "Marcatori illimitati",
      watermark: "Esporta con filigrana",
      no_watermark: "Esportazione completa (senza filigrana)",
      ai_detection: "Rilevamento dimensioni AI",
      choose_your_plan: "Scegli il Tuo Piano",
      unlock_potential: "Sblocca tutto il potenziale di SmartBalloon con le nostre funzionalità premium",
      loading_plans: "Caricamento piani...",
      popular: "POPOLARE",
      best_value: "MIGLIOR VALORE",
      your_plan: "IL TUO PIANO",
      plus_vat: "+ IVA",
      ai_plan_desc: "Rilevamento AI per viste - 50 crediti/mese",
      ai_unlimited_desc: "AI Illimitato - scansiona tutte le viste senza limiti",
      markers_unlimited: "Markers illimitati",
      ai_view_detection: "AI View-Based detection",
      ai_credits_50: "50 crediti AI/mese (~12 viste)",
      credits_per_view: "~4 crediti per scansione vista",
      manual_clicks_free: "Click AI manuali GRATIS",
      full_export: "Export PDF & Excel completo",
      smartrevision_basic: "SmartRevision base",
      everything_in_ai: "Tutto incluso in AI",
      unlimited_ai_credits: "Crediti AI ILLIMITATI",
      unlimited_view_scans: "Scansioni viste illimitate",
      priority_support: "Supporto prioritario",
      smartrevision_unlimited: "SmartRevision illimitato",
      change_plan: "Cambia Piano",
      manage_subscription: "Gestisci Abbonamento",
      manage_subscription_desc: "Annulla, aggiorna pagamento, scarica fatture",
      
      // Trial System
      trial_plan: "Prova AI di 7 giorni",
      trial_plan_short: "Prova AI",
      try_free_7_days: "Provami gratis per 7gg",
      trial_description: "Accesso completo all'AI per 7 giorni - senza carta di credito",
      trial_includes: "La prova include",
      trial_smartballoon_limit: "1 progetto SmartBalloon con AI illimitata",
      trial_smartrevision_limit: "2 comparazioni SmartRevision con AI completa",
      trial_no_export: "L'esportazione PDF richiede abbonamento",
      trial_days_remaining: "giorni rimanenti",
      trial_day_remaining: "giorno rimanente",
      trial_expires_today: "La prova scade oggi",
      trial_expired: "Prova Scaduta",
      trial_expired_title: "La tua prova AI è scaduta",
      trial_expired_message: "Passa a un piano attivo per continuare a utilizzare SmartBalloon e SmartRevision con tutte le funzionalità AI.",
      trial_project_limit_title: "Limite Progetti Raggiunto",
      trial_project_limit_message: "Il tuo AI Trial include 1 progetto. Passa a un piano superiore per creare altri progetti.",
      trial_comparison_limit_title: "Limite Comparazioni Raggiunto",
      trial_comparison_limit_message: "Il tuo AI Trial include 2 comparazioni. Passa a un piano superiore per crearne altre.",
      trial_export_blocked_title: "Esportazione Non Disponibile",
      trial_export_blocked_message: "Vorresti esportare in PDF? Passa a un piano a pagamento per sbloccare l'esportazione PDF e Excel.",
      upgrade_now: "Abbonati Ora",
      view_plans: "Vedi Piani",
      start_trial: "Inizia Prova Gratuita",
      trial_active: "Prova Attiva",
      trial_badge: "PROVA",
      
      // Subscription cancelled (but still active until period end)
      subscription_cancelled: "Abbonamento Annullato",
      subscription_cancelled_banner: "Il tuo abbonamento è stato annullato",
      subscription_access_until: "Continuerai ad avere accesso fino al",
      subscription_days_remaining: "giorni rimanenti",
      subscription_day_remaining: "giorno rimanente",
      subscription_expires_today: "L'abbonamento scade oggi",
      subscription_reactivate: "Riattiva Abbonamento",
      subscription_cancelled_hint: "Il tuo piano passerà a FREE dopo questa data",
      
      // Messages
      project_created: "Progetto creato",
      project_deleted: "Progetto eliminato",
      changes_saved: "Modifiche salvate",
      upload_success: "File caricato",
      export_started: "Esportazione avviata",
      marker_limit: "Limite marcatori raggiunto. Aggiorna a PRO per marcatori illimitati.",
      
      // Quality warnings
      quality_warning_title: "Attenzione: Qualità Ridotta",
      quality_warning_large_file: "Il file è molto grande. La risoluzione è stata ridotta per consentire il caricamento.",
      quality_warning_large_image: "L'immagine è stata ridimensionata per consentire il caricamento.",
      quality_warning_ocr_note: "La lettura automatica delle quote potrebbe risultare meno precisa. Per risultati ottimali, considera di usare un PDF a risoluzione inferiore o inserire i valori manualmente.",
      upload_error_too_large: "File troppo grande",
      upload_error_timeout: "Timeout durante il caricamento. Il file potrebbe essere troppo grande.",
      
      // Welcome popup
      welcome_title: "Benvenuto in SmartBalloon!",
      welcome_subtitle: "Tutto pronto! Ecco come iniziare:",
      welcome_step1_title: "Crea un nuovo progetto",
      welcome_step1_desc: "Clicca \"Nuovo Progetto\" per iniziare",
      welcome_step2_title: "Carica il tuo disegno",
      welcome_step2_desc: "Carica un PDF o un'immagine da pallinare",
      welcome_step3_title: "Posiziona i pallini",
      welcome_step3_desc: "Clicca sulle quote per aggiungere i marcatori",
      welcome_button: "Capito, iniziamo!",
      
      // Hero Section (Login Page)
      hero_title: "Gestisci qualità e disegni tecnici in pochi secondi",
      hero_subtitle: "Dalla creazione dei balloon al confronto revisioni con AI",
      hero_step1: "Carica disegno",
      hero_step2: "Rileva quote",
      hero_step3: "Confronta revisioni",
      
      // SmartBalloon Card
      smartballoon_title: "SmartBalloon",
      smartballoon_subtitle: "Crea balloon, genera ISIR e gestisci il controllo qualità in modo automatico",
      smartballoon_feature1: "Balloon automatici con AI",
      smartballoon_feature2: "Generazione report ISIR",
      smartballoon_feature3: "Gestione completa delle quote",
      
      // SmartRevision Card
      smartrevision_headline: "Non fidarti solo del cartiglio.",
      smartrevision_subheadline: "Confronta due revisioni e scopri ogni modifica in pochi secondi",
      smartrevision_title: "SmartRevision",
      smartrevision_subtitle: "Analizza differenze tra disegni e previeni errori in produzione",
      smartrevision_feature1: "Rileva differenze automaticamente",
      smartrevision_feature2: "Evidenzia modifiche critiche",
      smartrevision_feature3: "Riduce errori in produzione",
      
      hero_ai_premium: "Disponibile con",
      
      // ComparePage - SmartRevision Workspace
      old_revision: "Vecchia Revisione",
      new_revision: "Nuova Revisione",
      all_comparisons: "Tutte le comparazioni",
      export_pdf: "Esporta PDF",
      differences: "Differenze",
      found: "trovate",
      vector: "Vettoriale",
      opacity: "Opacità",
      start_smartrevision: "Avvia SmartRevision",
      legend: "Legenda",
      legend_desc: "Le differenze sono evidenziate con cerchi/ellissi colorati per mantenere leggibili i valori originali.",
      removed: "Rimosso",
      added: "Aggiunto",
      modified: "Modificato",
      removed_desc: "presente in {oldRev}, assente in {newRev}",
      added_desc: "assente in {oldRev}, presente in {newRev}",
      summary: "Riepilogo:",
      differences_list: "Elenco Differenze",
      importance: "Importanza:",
      importance_high: "alta",
      importance_medium: "media",
      importance_low: "bassa",
      visual_diffs_detected: "Differenze visive rilevate. Dettagli semantici non disponibili.",
      upload_both_drawings: "Carica entrambi i disegni",
      then_click: "poi clicca",
      green_added: "Verde (Aggiunto)",
      red_removed: "Rosso (Rimosso)",
      yellow_modified: "Giallo (Modificato)",
      diff_editor: "Editor Differenze",
      add_note: "Aggiungi nota",
      add_circle: "Aggiungi cerchio",
      undo: "Annulla",
      save_changes: "Salva modifiche",
      saved: "Salvato",
      delete_circle: "Elimina cerchio",
      editor_instructions_line1: "Click su cerchio/nota per selezionare • Drag per spostare • DEL per eliminare",
      editor_instructions_line2: "Trascina quadratini per ridimensionare • Scroll per zoom • Ctrl+Z annulla",
      note_text_label: "Testo della nota:",
      loading_high_res: "Caricamento immagine ad alta risoluzione...",
      loading_high_res_desc: "Questo permette la massima qualità per i disegni tecnici",
      new_comparison_name: "Nuova comparazione",
      guided_comparison_title: "Devi confrontare solo una o più viste del disegno?",
      guided_comparison_desc: "Utilizza la Comparazione Guidata per Vista",
      guided_comparison_hint: "Usa questa modalità quando le viste sono state spostate tra revisioni",
      ai_credits_10: "L'analisi costa 10 crediti AI.",
      differences_found: "Differenze trovate:",
      zero_differences_title: "Nessuna differenza trovata",
      zero_differences_message: "La comparazione automatica ha trovato 0 differenze. Sei sicuro si tratti dello stesso disegno in revisioni diverse?",
      zero_differences_hint: "In caso positivo, prova ad aiutarmi utilizzando la Comparazione per Viste per selezionare manualmente le aree specifiche da confrontare.",
      try_guided_comparison: "Prova Comparazione Guidata",
      tutorial_upload_old: "Carica la vecchia revisione",
      tutorial_upload_old_desc: "Carica il disegno della revisione precedente (PDF o immagine).",
      tutorial_upload_new: "Carica la nuova revisione",
      tutorial_upload_new_desc: "Carica il disegno della nuova revisione da confrontare.",
      tutorial_start_analysis: "Avvia l'analisi",
      tutorial_start_analysis_desc: "L'AI rileverà automaticamente le differenze tra le due revisioni.",
      tutorial_open_editor: "Apri l'editor",
      tutorial_open_editor_desc: "Controlla e modifica i marker delle differenze nell'editor fullscreen.",
      user_circle: "(utente)",
      new_note: "Nuova nota",
      guided_results_title: "Risultati Comparazione Guidata",
      views_analyzed: "viste analizzate",
      credits_consumed: "Crediti consumati",
      no_differences: "Nessuna differenza rilevata.",
      
      // Dashboard & Folders
      new_folder: "Nuova Cartella",
      folder_name: "Nome Cartella",
      folder_placeholder: "Es: Clienti 2026",
      create_folder: "Crea Cartella",
      rename_project: "Rinomina Progetto",
      move_to: "Sposta in",
      move_to_root: "Sposta nella root",
      no_description: "Nessuna descrizione",
      upload_logo: "Carica Logo",
      upload_company_logo: "Carica il logo della tua azienda. Verrà utilizzato nei report ISIR.",
      logo_uploaded: "Logo aziendale caricato!",
      logo_deleted: "Logo eliminato",
      logo_only_images: "Solo immagini sono permesse",
      logo_too_large: "Logo troppo grande. Massimo 500KB",
      folder_created: "Cartella creata",
      folder_deleted: "Cartella eliminata",
      project_renamed: "Progetto rinominato",
      project_moved: "Progetto spostato",
      confirm_delete_folder: "Eliminare questa cartella? I progetti verranno spostati nella root.",
      confirm_delete_project: "Sei sicuro di voler eliminare questo progetto?",
      
      // SmartRevision Page
      smartrevision_page_title: "SmartRevision",
      smartrevision_page_subtitle: "Analizza differenze tra disegni",
      new_comparison: "Nuova Comparazione",
      comparison_name: "Nome Comparazione",
      comparison_description: "Descrizione (opzionale)",
      create_comparison: "Crea Comparazione",
      no_comparisons: "Nessuna comparazione",
      no_comparisons_desc: "Crea la tua prima comparazione per analizzare le differenze tra disegni",
      upgrade_to_ai: "Upgrade a Piano AI",
      starting_from: "A partire da €99.99/mese + IVA - 10 crediti per analisi",
      features_included: "Funzionalità incluse:",
      visual_comparison: "Confronto visivo automatico",
      semantic_analysis: "Analisi semantica con AI",
      pdf_export_report: "Export PDF con report dettagliato",
      save_comparisons: "Salvataggio comparazioni",
      credits_label: "Crediti:",
      open_comparison: "Apri",
      delete_comparison: "Elimina",
      confirm_delete_comparison: "Sei sicuro di voler eliminare questa comparazione?",
      comparison_deleted: "Comparazione eliminata",
      comparison_created: "Comparazione creata",
      
      // SmartRevision Status & UI
      status_completed: "Completata",
      status_analyzing: "In analisi...",
      status_failed: "Errore",
      status_pending: "In attesa",
      credits_used: "Crediti usati:",
      no_folder: "Senza cartella",
      move_to_folder: "Sposta in cartella",
      remove_from_folder: "Rimuovi da cartella",
      vs: "vs",
      
      // GuidePage
      back: "Indietro",
      guide_title: "Guida SmartBalloon",
      print_save_pdf: "Stampa / Salva PDF",
      go_to_dashboard: "Vai alla Dashboard",
      table_of_contents: "INDICE",
      guide_intro: "Introduzione",
      guide_upload: "1. Caricamento Disegno",
      guide_views: "2. Definire le Viste",
      guide_ai_detection: "3. Rilevamento AI",
      guide_markers: "4. Gestione Markers",
      guide_cmm: "5. Import CMM",
      guide_export: "6. Esportazione",
      guide_smartrevision: "7. SmartRevision",
      guide_projects: "Gestione Progetti",
      guide_settings: "Impostazioni",
      guide_faq: "FAQ",
      guide_welcome_title: "Benvenuto in SmartBalloon",
      guide_welcome_desc: "SmartBalloon è uno strumento professionale per la creazione di disegni balloonati e report ISIR (Initial Sample Inspection Report) per i processi di qualità industriale.",
      guide_step_upload: "Carica",
      guide_step_upload_desc: "Carica il tuo disegno tecnico PDF",
      guide_step_detect: "Rileva",
      guide_step_detect_desc: "L'AI rileva automaticamente le quote",
      guide_step_export: "Esporta",
      guide_step_export_desc: "Genera PDF balloonato e report ISIR",
      guide_tip_vector: "Per ottenere i migliori risultati, utilizza PDF vettoriali generati direttamente dal tuo software CAD (SolidWorks, AutoCAD, Inventor, etc.). I PDF scansionati potrebbero avere risultati meno precisi.",
      guide_features_title: "Cosa puoi fare con SmartBalloon:",
      guide_feature_1: "Rilevare automaticamente le quote dai disegni tecnici usando AI",
      guide_feature_2: "Creare markers numerati (balloon) sulle quote",
      guide_feature_3: "Importare dati da macchine di misura CMM",
      guide_feature_4: "Generare report ISIR in formato Excel con formule OK/NOK",
      guide_feature_5: "Esportare disegni balloonati in PDF",
      guide_feature_6: "Organizzare i progetti in cartelle",
      guide_upload_title: "1. Caricamento del Disegno",
      guide_upload_intro: "Il primo passo è caricare il disegno tecnico che vuoi analizzare.",
      guide_upload_step1_title: "Crea un nuovo progetto",
      guide_upload_step1_desc1: "Dalla Dashboard, clicca sul pulsante \"Nuovo Progetto\".",
      guide_upload_step1_desc2: "Inserisci un nome descrittivo per il progetto (es. \"Albero motore REV.A\").",
      guide_upload_step2_title: "Carica il disegno PDF",
      guide_upload_step2_desc1: "Nel pannello di sinistra, troverai l'area \"Carica Disegno\".",
      guide_upload_step2_desc2: "Puoi:",
      guide_upload_step2_opt1: "Trascinare il file PDF direttamente nell'area",
      guide_upload_step2_opt2: "Cliccare per aprire il selettore file",
      guide_upload_step2_formats: "Formati supportati: PDF, PNG, JPG",
      guide_upload_step3_title: "Attendi l'elaborazione",
      guide_upload_step3_desc1: "Il sistema analizzerà il file e lo preparerà per la visualizzazione.",
      guide_upload_step3_desc2: "Se il PDF è vettoriale (generato da CAD), vedrai un'icona verde che indica che potrai usare il rilevamento vettoriale.",
      guide_upload_step3_tip: "Per disegni molto grandi (es. formato A0), il sistema li divide automaticamente in 'tiles' per una migliore gestione.",
      guide_vector_vs_raster: "PDF Vettoriale vs Raster: I PDF vettoriali permettono un rilevamento delle quote più preciso perché il testo è già codificato nel file. I PDF scansionati (raster) richiedono OCR e possono essere meno accurati.",
      guide_views_title: "2. Definire le Viste (Views)",
      guide_views_intro: "Le Viste sono aree rettangolari del disegno che verranno analizzate dall'AI per rilevare le quote.",
      guide_views_step1_title: "Attiva lo strumento Vista",
      guide_views_step1_desc1: "Nel pannello di sinistra, clicca su \"Vista\" nella sezione Strumenti.",
      guide_views_step1_desc2: "Il cursore cambierà in una croce.",
      guide_views_step2_title: "Disegna l'area della vista",
      guide_views_step2_desc1: "Clicca e trascina sul disegno per definire l'area rettangolare.",
      guide_views_step2_desc2: "Cerca di includere solo le quote che vuoi rilevare, evitando bordi e cartigli.",
      guide_views_step2_tip: "Crea viste più piccole e focalizzate per risultati migliori. Evita di includere troppe quote in una singola vista.",
      guide_views_step3_title: "Ripeti per altre aree",
      guide_views_step3_desc1: "Puoi creare più viste per coprire diverse aree del disegno.",
      guide_views_step3_desc2: "Ogni vista verrà analizzata separatamente.",
      guide_views_credits_warning: "Importante: Ogni vista consuma circa 2 crediti AI quando viene analizzata. Se hai un piano con crediti limitati, pianifica le viste con attenzione.",
      guide_ai_title: "3. Rilevamento Quote con AI",
      guide_ai_intro: "SmartBalloon utilizza l'intelligenza artificiale per rilevare automaticamente le quote dal disegno.",
      guide_ai_methods_title: "Metodi di Rilevamento:",
      guide_ai_vector_title: "Rilevamento Vettoriale (Consigliato)",
      guide_ai_vector_desc: "Per PDF vettoriali. Estrae le quote direttamente dal file PDF, poi usa l'AI per raffinare i risultati.",
      guide_ai_vector_cost: "Costo: 2-3 crediti | Precisione: Alta",
      guide_ai_vector_how: "Come usarlo: Clicca il pulsante \"Rileva Quote AI\" nel pannello di destra.",
      guide_ai_views_title: "Rilevamento per Viste",
      guide_ai_views_desc: "Analizza le viste che hai definito usando l'intelligenza artificiale.",
      guide_ai_views_cost: "Costo: ~2 crediti per vista | Precisione: Buona",
      guide_ai_views_how: "Come usarlo: Dopo aver creato le viste, clicca \"Analizza questa Vista\" su ogni vista.",
      guide_ai_manual_title: "Click Manuale (Gratuito)",
      guide_ai_manual_desc: "Clicca direttamente su una quota per farla leggere dall'AI.",
      guide_ai_manual_cost: "Costo: Gratuito | Precisione: Molto alta",
      guide_ai_manual_how: "Come usarlo: Attiva lo strumento \"Marker\" e clicca su una quota.",
      guide_ai_review_title: "Rivedi i suggerimenti",
      guide_ai_review_desc1: "I suggerimenti dell'AI appariranno nel pannello \"Suggerimenti AI\".",
      guide_ai_review_desc2: "Per ogni suggerimento puoi:",
      guide_ai_review_accept: "Accept: Accetta e crea il marker",
      guide_ai_review_modify: "Modify: Modifica i valori prima di accettare",
      guide_ai_review_reject: "Reject: Scarta il suggerimento",
      guide_ai_review_tip: "Puoi modificare i valori prima di accettarli cliccando su 'Modify' su ogni suggerimento.",
      guide_markers_title: "4. Gestione dei Markers",
      guide_markers_intro: "I markers (o balloon) sono i numeri cerchiati che identificano ogni quota sul disegno.",
      guide_markers_step1_title: "Visualizza i markers",
      guide_markers_step1_desc1: "I markers accettati appaiono come cerchi numerati sul disegno.",
      guide_markers_step1_desc2: "Clicca su un marker per selezionarlo e vedere i suoi dettagli nel pannello \"Properties\".",
      guide_markers_step2_title: "Modifica un marker",
      guide_markers_step2_desc: "Con un marker selezionato, nel pannello Properties puoi modificare:",
      guide_markers_field_number: "Numero: Il numero del balloon (es. 173, 184...)",
      guide_markers_field_nominal: "Nominale: Il valore della quota",
      guide_markers_field_tolerance: "Tolleranze: Tol+ e Tol-",
      guide_markers_field_description: "Descrizione: Testo descrittivo della quota",
      guide_markers_step3_title: "Sposta un marker",
      guide_markers_step3_desc1: "Trascina un marker per spostarlo in una posizione migliore sul disegno.",
      guide_markers_step3_desc2: "Questo è utile se l'AI ha posizionato il marker in un punto poco visibile.",
      guide_markers_step3_tip: "I numeri dei markers sono persistenti: puoi assegnare qualsiasi numero e rimarrà anche dopo aver chiuso e riaperto il progetto.",
      guide_markers_step4_title: "Elimina un marker",
      guide_markers_step4_desc1: "Seleziona il marker e clicca l'icona cestino nel pannello Properties.",
      guide_markers_step4_desc2: "Oppure usa il pulsante \"Delete\" con il marker selezionato.",
      guide_markers_numbering_info: "Numerazione personalizzata: Puoi assegnare qualsiasi numero ai markers. Se elimini un marker, gli altri manterranno i loro numeri originali.",
      guide_cmm_title: "5. Importazione Dati CMM",
      guide_cmm_intro: "Puoi importare i valori misurati direttamente dalle tue macchine di misura (CMM) caricando fino a 5 report PDF per progetto.",
      guide_cmm_new_feature: "Novità: Ora puoi caricare fino a 5 report CMM per progetto. Il sistema rileva automaticamente le quote duplicate e ti chiede quale valore mantenere.",
      guide_cmm_step1_title: "Prepara i report CMM",
      guide_cmm_step1_desc: "I report CMM devono essere in formato PDF e contenere identificatori SB per ogni quota:",
      guide_cmm_step1_format: "Formato: SB + numero marker (es. SB131, sb45). Maiuscole/minuscole non importano.",
      guide_cmm_step2_title: "Carica i report",
      guide_cmm_step2_desc1: "Nel pannello Upload a destra, troverai la sezione \"Report CMM (PDF) - Max 5\".",
      guide_cmm_step2_desc2: "Trascina uno o più file PDF nell'area",
      guide_cmm_step2_desc3: "Oppure clicca per aprire il selettore file",
      guide_cmm_step2_desc4: "Puoi caricare fino a 5 report per progetto",
      guide_cmm_step2_note: "I report caricati appaiono in lista con possibilità di eliminarli singolarmente.",
      guide_cmm_step3_title: "Importa le misure",
      guide_cmm_step3_desc: "Clicca \"Importa da X Report\" per avviare l'analisi.",
      guide_cmm_step3_process1: "Estrae tutti i valori SB dai PDF caricati",
      guide_cmm_step3_process2: "Rileva eventuali quote duplicate",
      guide_cmm_step3_process3: "Mostra un'anteprima prima dell'importazione",
      guide_cmm_step3_tip: "Se lo stesso numero SB appare in più report (es. SB45 in Report_Lotto1.pdf e Report_Lotto2.pdf), il sistema ti chiederà quale valore tenere.",
      guide_cmm_step4_title: "Risolvi le quote duplicate",
      guide_cmm_step4_desc: "Se vengono trovate quote duplicate, apparirà un dialog per ogni duplicato:",
      guide_cmm_step4_action: "Seleziona quale valore mantenere per ogni quota duplicata.",
      guide_cmm_step5_title: "Conferma l'importazione",
      guide_cmm_step5_desc: "Dopo aver risolto eventuali duplicati, vedrai l'anteprima finale.",
      guide_cmm_step5_check: "Spunta le quote che vuoi importare",
      guide_cmm_step5_apply: "Clicca \"Applica Misure Selezionate\"",
      guide_cmm_step5_result: "I valori misurati verranno associati ai marker corrispondenti.",
      guide_cmm_oknok_info: "Formule OK/NOK: Una volta importati i valori misurati, l'export Excel ISIR calcolerà automaticamente se ogni quota è OK (dentro tolleranza) o NOK (fuori tolleranza).",
      guide_cmm_summary_title: "Riepilogo funzionalità CMM:",
      guide_cmm_summary_1: "Fino a 5 report PDF per progetto",
      guide_cmm_summary_2: "Rilevamento automatico identificatori SB + numero",
      guide_cmm_summary_3: "Gestione quote duplicate con scelta del valore",
      guide_cmm_summary_4: "Indicazione del file sorgente per ogni valore",
      guide_cmm_summary_5: "Anteprima e selezione prima dell'importazione",
      guide_export_title: "6. Esportazione Documenti",
      guide_export_intro: "SmartBalloon permette di esportare i risultati in diversi formati.",
      guide_export_pdf_title: "PDF Balloonato",
      guide_export_pdf_desc: "Genera un PDF con il disegno originale e tutti i markers (balloon) sovrapposti. Ideale per la documentazione di produzione.",
      guide_export_pdf_how: "Come: Pannello Export → \"PDF\"",
      guide_export_excel_title: "Report ISIR Excel",
      guide_export_excel_desc: "Genera un report Excel con tutte le quote, tolleranze, valori misurati e formule OK/NOK automatiche.",
      guide_export_excel_how: "Come: Pannello Export → \"Excel\"",
      guide_export_excel_features_title: "Caratteristiche Excel ISIR:",
      guide_export_excel_feature_1: "Logo aziendale in alto a destra (caricalo dalla Dashboard)",
      guide_export_excel_feature_2: "Informazioni progetto (nome, descrizione, tolleranze generali)",
      guide_export_excel_feature_3: "Tabella con tutte le quote e i valori",
      guide_export_excel_feature_4: "Formule automatiche OK/NOK basate sulle tolleranze",
      guide_export_excel_feature_5: "Intestazione ripetuta su ogni pagina stampata",
      guide_export_excel_feature_6: "Numero di pagina automatico (\"Pagina X di Y\")",
      guide_export_logo_info: "Logo Aziendale: Per includere il logo della tua azienda nei report, vai nella Dashboard e clicca su \"Carica Logo\" prima di esportare.",
      guide_smartrevision_title: "7. SmartRevision",
      guide_smartrevision_subtitle: "(analizza differenze fra disegni)",
      guide_smartrevision_intro: "SmartRevision ti permette di confrontare due revisioni di un disegno tecnico e identificare automaticamente tutte le differenze.",
      guide_smartrevision_nav_info: "Navigazione: Puoi accedere a SmartRevision dalla navigazione in alto, cliccando sul tab \"SmartRevision\" accanto a \"SmartBalloon\".",
      guide_smartrevision_credits_warning: "Crediti AI: Ogni analisi SmartRevision costa 10 crediti AI. Disponibile per piani AI e AI Unlimited.",
      guide_smartrevision_step1_title: "Crea una nuova comparazione",
      guide_smartrevision_step1_desc1: "Dalla navigazione in alto, vai su SmartRevision.",
      guide_smartrevision_step1_desc2: "Clicca \"Nuova Comparazione\" e assegna un nome descrittivo (es. \"Parte XYZ - Rev A vs Rev B\").",
      guide_smartrevision_step2_title: "Carica i disegni",
      guide_smartrevision_step2_desc: "Nella pagina comparazione, carica:",
      guide_smartrevision_step2_old: "Vecchia Revisione: La revisione precedente (PDF o immagine)",
      guide_smartrevision_step2_new: "Nuova Revisione: La revisione nuova (PDF o immagine)",
      guide_smartrevision_step2_vector: "Il sistema rileverà automaticamente se il PDF è vettoriale.",
      guide_smartrevision_step2_rename: "Rinomina: Clicca sul nome \"Vecchia Revisione\" o \"Nuova Revisione\" per assegnare nomi personalizzati.",
      guide_smartrevision_step3_title: "Avvia SmartRevision",
      guide_smartrevision_step3_desc: "Clicca \"Avvia SmartRevision\". Il sistema:",
      guide_smartrevision_step3_process1: "Allinea automaticamente i due disegni",
      guide_smartrevision_step3_process2: "Rileva le differenze visive con OpenCV (clustering intelligente)",
      guide_smartrevision_step3_process3: "Analizza semanticamente le modifiche con l'intelligenza artificiale",
      guide_smartrevision_step3_tip: "L'analisi può richiedere 30-60 secondi per disegni complessi. Un banner di caricamento ti terrà informato.",
      guide_smartrevision_step4_title: "Analizza i risultati",
      guide_smartrevision_step4_desc: "I risultati mostrano cerchi/ellissi che evidenziano le aree modificate:",
      guide_smartrevision_color_red: "Rosso: Elementi rimossi (presenti in A, assenti in B)",
      guide_smartrevision_color_green: "Verde: Elementi aggiunti (assenti in A, presenti in B)",
      guide_smartrevision_color_yellow: "Giallo: Elementi modificati (valori diversi)",
      guide_smartrevision_overlay_note: "L'overlay usa cerchi/ellissi con contorno per non oscurare il testo sottostante.",
      guide_smartrevision_step4_1_title: "Editor Fullscreen (opzionale)",
      guide_smartrevision_step4_1_desc: "Clicca sulla card \"Differenze\" per aprire l'editor a schermo intero.",
      guide_smartrevision_step4_1_tip: "L'editor fullscreen ti permette di confrontare visivamente A e B con precisione e modificare i marker.",
      guide_smartrevision_editor_features: "Funzionalità disponibili:",
      guide_smartrevision_editor_slider: "Slider Vecchia↔Nuova: Regola l'opacità per passare gradualmente dalla Vecchia Revisione alla Nuova Revisione",
      guide_smartrevision_editor_zoom: "Zoom: Usa i pulsanti +/- o la rotellina del mouse (zoom centrato sul cursore)",
      guide_smartrevision_editor_pan: "Pan: Trascina lo sfondo per spostarti",
      guide_smartrevision_editor_select: "Seleziona marker: Click su un marker per selezionarlo (appaiono 4 quadratini bianchi agli angoli)",
      guide_smartrevision_editor_move: "Sposta marker: Trascina un marker selezionato per riposizionarlo",
      guide_smartrevision_editor_resize: "Ridimensiona marker: Trascina uno dei 4 quadratini bianchi agli angoli per modificare le dimensioni",
      guide_smartrevision_editor_delete: "Elimina marker: Premi DEL o usa il pulsante \"Elimina cerchio\"",
      guide_smartrevision_editor_add: "Aggiungi cerchio: Clicca \"Aggiungi cerchio\" e seleziona il colore (Verde=Aggiunto, Rosso=Rimosso, Giallo=Modificato)",
      guide_smartrevision_editor_note: "Aggiungi nota: Clicca \"Aggiungi nota\" per inserire un box di testo",
      guide_smartrevision_editor_edit_note: "Modifica nota: Seleziona una nota e modifica il testo nel campo che appare in alto a sinistra",
      guide_smartrevision_editor_resize_note: "Ridimensiona nota: Trascina i quadratini bianchi agli angoli della nota",
      guide_smartrevision_editor_undo: "Annulla: Ctrl+Z o pulsante \"Annulla\" (ultime 20 azioni)",
      guide_smartrevision_editor_save: "Salva modifiche: Clicca \"Salva modifiche\" (verde) per salvare le correzioni nel database",
      guide_smartrevision_editor_important: "Importante: Le modifiche ai marker e alle note vengono salvate solo premendo \"Salva modifiche\". L'esportazione PDF includerà sempre le modifiche correnti dell'editor, incluse le note di testo.",
      guide_smartrevision_user_circles: "Nota: I cerchi aggiunti dall'utente sono visualizzati con linea tratteggiata e la lettera \"U\" sopra. Nel PDF esportato, la sezione \"Modifiche Operatore\" elenca tutte le modifiche manuali (cerchi aggiunti, eliminati o riposizionati).",
      guide_smartrevision_step5_title: "Esporta il report PDF",
      guide_smartrevision_step5_desc: "Clicca \"Esporta PDF\" per generare un documento con:",
      guide_smartrevision_step5_page1: "Pagina 1: Overlay delle differenze (dimensioni originali della Vecchia Revisione)",
      guide_smartrevision_step5_page2: "Pagina 2+: Legenda colori e elenco differenze semantiche",
      guide_smartrevision_format_preserved: "Formato preservato: L'output PDF mantiene sempre le dimensioni e il formato della Vecchia Revisione (es. A0 orizzontale, A3, ecc.). Le note sono su pagine A4 separate per leggibilità.",
      guide_smartrevision_use_cases_title: "Casi d'uso comuni:",
      guide_smartrevision_use_case_1: "Confronto revisioni dello stesso codice (Rev A vs Rev B)",
      guide_smartrevision_use_case_2: "Confronto varianti di prodotto (codici simili con piccole differenze)",
      guide_smartrevision_use_case_3: "Verifica modifiche richieste dal cliente",
      guide_smartrevision_use_case_4: "Audit trail delle modifiche progettuali",
      guide_smartrevision_use_case_5: "Controllo qualità pre-produzione",
      guide_smartrevision_advanced_title: "Funzionalità avanzate:",
      guide_smartrevision_advanced_1: "Clustering intelligente: Le differenze vicine vengono raggruppate automaticamente",
      guide_smartrevision_advanced_2: "Filtro linee geometriche: Le linee sottili vengono filtrate per evidenziare solo le modifiche significative",
      guide_smartrevision_advanced_3: "Controllo opacità: Regola l'opacità dell'overlay per vedere meglio il disegno sottostante",
      guide_smartrevision_advanced_4: "Rinomina disegni: Personalizza i nomi \"Vecchia Revisione\" e \"Nuova Revisione\" cliccando su di essi",
      guide_smartrevision_advanced_5: "Editor fullscreen: Confronta A vs B visivamente e modifica i marker direttamente",
      guide_smartrevision_advanced_6: "Ridimensiona marker: Trascina i quadratini bianchi per regolare le dimensioni dei cerchi",
      guide_smartrevision_advanced_7: "Cerchi personalizzati: Inserisci cerchi verde/rosso/giallo per segnalare modifiche non rilevate automaticamente",
      guide_smartrevision_advanced_8: "Note di testo: Aggiungi annotazioni testuali sul disegno, ridimensionabili e salvabili",
      guide_smartrevision_advanced_9: "Tracciamento modifiche: Nel PDF esportato viene indicato \"Rimosso da utente\", \"Aggiunto da utente\", ecc.",
      guide_smartrevision_advanced_10: "Salva modifiche: Persisti le correzioni manuali nel database prima di esportare",
      guide_smartrevision_advanced_11: "Esporta direttamente: Puoi esportare il PDF sia dalla pagina principale che dall'editor fullscreen",
      guide_smartrevision_guided_title: "AVANZATO",
      guide_smartrevision_guided_subtitle: "Comparazione Guidata per Vista",
      guide_smartrevision_guided_desc: "Per disegni con layout modificato tra le revisioni (es. viste spostate, sezioni riposizionate).",
      guide_smartrevision_guided_when_title: "Quando usarla:",
      guide_smartrevision_guided_when_1: "Viste che sono state spostate in posizioni diverse",
      guide_smartrevision_guided_when_2: "Sezioni riposizionate all'interno del disegno",
      guide_smartrevision_guided_when_3: "Confronti complessi con layout completamente ridisegnato",
      guide_smartrevision_guided_when_4: "Quando l'analisi automatica non riesce ad allineare le viste",
      guide_smartrevision_guided_how_title: "Come funziona:",
      guide_smartrevision_guided_how_1: "Clicca \"Aggiungi vista\" nella sezione Comparazione Guidata",
      guide_smartrevision_guided_how_2: "Disegna un rettangolo sulla vecchia revisione (area da confrontare)",
      guide_smartrevision_guided_how_3: "Disegna il rettangolo corrispondente sulla nuova revisione",
      guide_smartrevision_guided_how_4: "Ripeti per ogni vista da confrontare",
      guide_smartrevision_guided_how_5: "Clicca \"Avvia Comparazione Guidata\"",
      guide_smartrevision_guided_cost: "Costo: 2 crediti AI per ogni vista confrontata",
      guide_smartrevision_popup_warning: "Popup bloccati? Se il PDF non si apre, verificare che il browser consenta i popup per questo sito. Un avviso ti ricorderà di controllare questa impostazione prima dell'esportazione.",
      guide_projects_title: "Gestione Progetti",
      guide_projects_intro: "Organizza i tuoi progetti in modo efficiente usando cartelle e le funzioni di gestione.",
      guide_projects_folders_title: "Cartelle",
      guide_projects_folder_step1_title: "Crea una cartella",
      guide_projects_folder_step1_desc1: "Nella Dashboard, clicca \"Nuova Cartella\".",
      guide_projects_folder_step1_desc2: "Assegna un nome e un colore per identificarla facilmente.",
      guide_projects_folder_step2_title: "Sposta progetti nelle cartelle",
      guide_projects_folder_step2_desc1: "Clicca sui tre puntini su una card progetto.",
      guide_projects_folder_step2_desc2: "Seleziona \"Sposta in\" e scegli la cartella di destinazione.",
      guide_projects_actions_title: "Azioni sui Progetti",
      guide_projects_action_rename: "Rinomina",
      guide_projects_action_rename_how: "Menu tre puntini → Rinomina",
      guide_projects_action_move: "Sposta",
      guide_projects_action_move_how: "Menu tre puntini → Sposta in",
      guide_projects_action_delete: "Elimina",
      guide_projects_action_delete_how: "Menu tre puntini → Delete",
      guide_settings_title: "Impostazioni e Configurazione",
      guide_settings_logo_title: "Logo Aziendale",
      guide_settings_logo_desc: "Dalla Dashboard, clicca su \"Carica Logo\" per caricare il logo della tua azienda. Questo logo apparirà nei report ISIR esportati.",
      guide_settings_logo_formats: "Formati supportati: PNG, JPG, SVG",
      guide_settings_logo_size: "Dimensione massima: 500KB",
      guide_settings_tolerance_title: "Tolleranze Generali ISO 2768",
      guide_settings_tolerance_desc: "Se il tuo disegno specifica tolleranze generali ISO 2768, SmartBalloon può applicarle automaticamente. Quando rileva quote senza tolleranze specificate, ti chiederà quale classe applicare (mK, fK, cK, vK).",
      guide_settings_api_title: "Chiave API OpenAI",
      guide_settings_api_desc: "Se vuoi usare la tua chiave API OpenAI invece dei crediti inclusi nel piano, puoi configurarla nelle impostazioni del profilo.",
      guide_faq_title: "Domande Frequenti (FAQ)",
      guide_faq_q1: "Quanti crediti AI ho a disposizione?",
      guide_faq_a1: "Dipende dal tuo piano. Il piano AI include 50 crediti/mese, il piano AI Unlimited ha crediti illimitati. Puoi vedere i crediti rimanenti nella Dashboard.",
      guide_faq_q2: "Il click manuale sulle quote è gratuito?",
      guide_faq_a2: "Sì! Il click manuale per leggere singole quote non consuma crediti AI.",
      guide_faq_q3: "Come faccio a sapere se il mio PDF è vettoriale?",
      guide_faq_a3: "Dopo aver caricato il PDF, vedrai un'icona verde 'Vector' se il PDF è vettoriale. I PDF generati da CAD sono quasi sempre vettoriali.",
      guide_faq_q4: "I numeri dei markers cambiano quando ne elimino uno?",
      guide_faq_a4: "No, i numeri dei markers sono persistenti. Se elimini il marker 5, i markers 4 e 6 manterranno i loro numeri.",
      guide_faq_q5: "Posso usare SmartBalloon offline?",
      guide_faq_a5: "No, SmartBalloon richiede una connessione internet per il funzionamento dell'AI e il salvataggio dei progetti.",
      guide_faq_q6: "Come posso contattare il supporto?",
      guide_faq_a6: "Puoi usare il chatbot DenAIs (icona in basso a destra) oppure scrivere a info@lscsrl.it",
      guide_faq_q7: "I miei disegni sono al sicuro?",
      guide_faq_a7: "Sì, i tuoi dati sono crittografati e archiviati in modo sicuro. Consulta la nostra Privacy Policy per maggiori dettagli.",
      guide_suggestion: "Suggerimento:",
      
      // CMM Import Modal
      cmm_interpret_title: "Come interpretare i report?",
      cmm_interpret_desc: "Hai caricato <strong>{count} report CMM</strong>. Come devono essere interpretati?",
      cmm_mode_manual_title: "Assegno manualmente i pezzi",
      cmm_mode_manual_desc: "<strong>Tu scegli</strong> quale report corrisponde a quale pezzo/campione.",
      cmm_mode_manual_hint: "Puoi rinominare i pezzi (es: \"Pezzo A\", \"Lotto 123\", etc.)",
      cmm_mode_multi_title: "Campioni multipli (automatico)",
      cmm_mode_multi_desc: "Ogni report è un <strong>pezzo/campione diverso</strong>, numerazione automatica.",
      cmm_mode_multi_hint: "Report 1 → P1, Report 2 → P2, etc.",
      cmm_mode_duplicate_title: "Report duplicati",
      cmm_mode_duplicate_desc: "I report contengono <strong>misure dello stesso pezzo</strong>.",
      cmm_mode_duplicate_hint: "Le quote duplicate verranno segnalate per scelta manuale.",
      cmm_continue: "Continua",
      cmm_assign_title: "Assegna i Report ai Pezzi",
      cmm_assign_desc: "Assegna un nome/numero a ogni report. Questo identificherà il pezzo nelle colonne dell'Excel ISIR.",
      cmm_assign_placeholder: "Es: P1, Pezzo A, Lotto 123",
      cmm_assign_tip: "Usa nomi brevi che appariranno come intestazioni colonna nell'Excel (es: P1, P2, Lotto A, etc.)",
      cmm_continue_import: "Continua con Importazione",
      cmm_duplicate_title: "Quota Duplicata - SB{id}",
      cmm_duplicate_desc: "Questa quota è presente in più report. Seleziona quale valore mantenere.",
      cmm_duplicate_count: "({current} di {total} duplicati)",
      cmm_duplicate_existing: "Marker esistente:",
      cmm_duplicate_current: "(attuale: {value})",
      cmm_duplicate_prev: "← Indietro",
      cmm_duplicate_next: "Avanti →",
      cmm_duplicate_confirm_all: "Conferma Tutti",
      
      // Manual Marker
      manual_marker: "Marker Manuale",
      manual_marker_desc: "Per quote che l'AI non riesce a leggere (ruotate, sfocate), usa \"Marker Manuale\".",
      manual_marker_warning: "Usa Marker Manuale anche per le tolleranze geometriche (planarità ⌂, parallelismo //, cilindricità ○, etc.)",
      manual_marker_insert: "Inserimento Marker Manuale",
    }
  },
  de: {
    translation: {
      // Common
      app_name: "SmartBalloon",
      save: "Speichern",
      cancel: "Abbrechen",
      delete: "Löschen",
      edit: "Bearbeiten",
      close: "Schließen",
      confirm: "Bestätigen",
      loading: "Laden...",
      error: "Fehler",
      success: "Erfolg",
      guide: "Anleitung",
      
      // Auth
      login: "Anmelden",
      register: "Registrieren",
      logout: "Abmelden",
      email: "E-Mail",
      password: "Passwort",
      name: "Name",
      forgot_password: "Passwort vergessen?",
      no_account: "Kein Konto?",
      have_account: "Bereits ein Konto?",
      login_success: "Anmeldung erfolgreich",
      register_success: "Registrierung erfolgreich",
      created_by_experience: "Erstellt aus der Erfahrung von",
      chat_bubble_message: "👋 Hallo! Ich bin DenAIs, schreib mir wenn du Hilfe brauchst!",
      chat_welcome_message: "Hallo, ich bin DenAIs, dein Assistent. Schreib mir wenn du Hilfe brauchst!\n\n• App-Nutzung\n• Zeichnungen hochladen\n• Marker erstellen\n• KI-Funktionen",
      denais_subtitle: "Dein SmartBalloon Assistent",
      
      // Navigation
      dashboard: "Dashboard",
      projects: "Projekte",
      subscription: "Abonnement",
      settings: "Einstellungen",
      
      // Projects
      new_project: "Neues Projekt",
      project_name: "Projektname",
      project_description: "Beschreibung",
      create_project: "Projekt erstellen",
      open_project: "Öffnen",
      delete_project: "Projekt löschen",
      no_projects: "Keine Projekte. Erstellen Sie Ihr erstes Projekt!",
      
      // Workspace
      upload_drawing: "Zeichnung hochladen",
      upload_logo: "Logo hochladen",
      drop_file: "Datei hierher ziehen oder klicken zum Durchsuchen",
      supported_formats: "Unterstützt: PDF, PNG, JPG",
      
      // Tools
      select_tool: "Auswählen",
      add_marker: "Markierung hinzufügen",
      zoom_in: "Vergrößern",
      zoom_out: "Verkleinern",
      fit_to_screen: "An Bildschirm anpassen",
      
      // Markers
      marker: "Markierung",
      markers: "Markierungen",
      description: "Beschreibung",
      nominal: "Nennwert",
      tolerance_plus: "Tol +",
      tolerance_minus: "Tol -",
      measured_value: "Gemessen",
      instrument: "Messgerät",
      resolution: "Auflösung",
      result: "Ergebnis",
      ok: "OK",
      not_ok: "NICHT OK",
      
      // AI
      ai_detect: "KI-Erkennung",
      ai_detecting: "Erkennung...",
      ai_premium_only: "KI-Erkennung ist mit dem AI Premium Plan verfügbar",
      ai_suggestions: "KI-Vorschläge",
      accept_all: "Alle akzeptieren",
      reject_all: "Alle ablehnen",
      
      // Export
      export: "Exportieren",
      export_pdf: "PDF exportieren",
      export_excel: "ISIR Excel exportieren",
      exporting: "Exportieren...",
      
      // Plans & Subscription Page
      free_plan: "Kostenlos",
      pro_plan: "Professionell",
      ai_plan: "AI Premium",
      current_plan: "Aktueller Plan",
      upgrade: "Upgraden",
      monthly: "Monat",
      features: "Funktionen",
      max_markers: "Markierungen maximal",
      unlimited_markers: "Unbegrenzte Markierungen",
      watermark: "Export mit Wasserzeichen",
      no_watermark: "Vollständiger Export (ohne Wasserzeichen)",
      ai_detection: "KI-Dimensionserkennung",
      choose_your_plan: "Wähle Deinen Plan",
      unlock_potential: "Entfalte das volle Potenzial von SmartBalloon mit unseren Premium-Funktionen",
      loading_plans: "Pläne werden geladen...",
      popular: "BELIEBT",
      best_value: "BESTER WERT",
      your_plan: "DEIN PLAN",
      plus_vat: "+ MwSt.",
      ai_plan_desc: "KI-Ansichtserkennung - 50 Credits/Monat",
      ai_unlimited_desc: "Unbegrenzte KI - alle Ansichten ohne Limits scannen",
      markers_unlimited: "Unbegrenzte Markers",
      ai_view_detection: "KI View-Based Erkennung",
      ai_credits_50: "50 KI-Credits/Monat (~12 Ansichten)",
      credits_per_view: "~4 Credits pro Ansichtsscan",
      manual_clicks_free: "Manuelle KI-Klicks KOSTENLOS",
      full_export: "Vollständiger PDF & Excel Export",
      smartrevision_basic: "SmartRevision basis",
      everything_in_ai: "Alles in AI enthalten",
      unlimited_ai_credits: "UNBEGRENZTE KI-Credits",
      unlimited_view_scans: "Unbegrenzte Ansichtsscans",
      priority_support: "Prioritätssupport",
      smartrevision_unlimited: "SmartRevision unbegrenzt",
      change_plan: "Plan Wechseln",
      manage_subscription: "Abo verwalten",
      manage_subscription_desc: "Kündigen, Zahlung aktualisieren, Rechnungen herunterladen",
      
      // Subscription cancelled
      subscription_cancelled: "Abo Gekündigt",
      subscription_cancelled_banner: "Ihr Abo wurde gekündigt",
      subscription_access_until: "Sie haben weiterhin Zugang bis",
      subscription_days_remaining: "Tage verbleibend",
      subscription_day_remaining: "Tag verbleibend",
      subscription_expires_today: "Abo läuft heute ab",
      subscription_reactivate: "Abo reaktivieren",
      subscription_cancelled_hint: "Ihr Plan wird nach diesem Datum auf FREE herabgestuft",
      
      // Messages
      project_created: "Projekt erstellt",
      project_deleted: "Projekt gelöscht",
      changes_saved: "Änderungen gespeichert",
      upload_success: "Datei hochgeladen",
      export_started: "Export gestartet",
      marker_limit: "Markierungslimit erreicht. Upgraden Sie auf PRO für unbegrenzte Markierungen.",
      
      // Welcome popup
      welcome_title: "Willkommen bei SmartBalloon!",
      welcome_subtitle: "Alles bereit! So starten Sie:",
      welcome_step1_title: "Neues Projekt erstellen",
      welcome_step1_desc: "Klicken Sie auf \"Neues Projekt\"",
      welcome_step2_title: "Zeichnung hochladen",
      welcome_step2_desc: "PDF oder Bild zum Markieren laden",
      welcome_step3_title: "Markierungen platzieren",
      welcome_step3_desc: "Klicken Sie auf Maße, um Markierungen hinzuzufügen",
      welcome_button: "Verstanden, los geht's!",
      
      // Hero Section (Login Page)
      hero_title: "Qualität und technische Zeichnungen in Sekunden verwalten",
      hero_subtitle: "Von der Balloon-Erstellung bis zum KI-gestützten Revisionsvergleich",
      hero_step1: "Zeichnung hochladen",
      hero_step2: "Maße erkennen",
      hero_step3: "Revisionen vergleichen",
      
      // SmartBalloon Card
      smartballoon_title: "SmartBalloon",
      smartballoon_subtitle: "Balloons erstellen, ISIR-Berichte generieren und Qualitätskontrolle automatisch verwalten",
      smartballoon_feature1: "Automatische KI-Balloons",
      smartballoon_feature2: "ISIR-Berichtsgenerierung",
      smartballoon_feature3: "Vollständige Maßverwaltung",
      
      // SmartRevision Card
      smartrevision_headline: "Vertrauen Sie nicht nur dem Schriftfeld.",
      smartrevision_subheadline: "Vergleichen Sie zwei Revisionen und entdecken Sie jede Änderung in Sekunden",
      smartrevision_title: "SmartRevision",
      smartrevision_subtitle: "Unterschiede zwischen Zeichnungen analysieren und Produktionsfehler vermeiden",
      smartrevision_feature1: "Automatische Differenzerkennung",
      smartrevision_feature2: "Kritische Änderungen hervorheben",
      smartrevision_feature3: "Reduziert Produktionsfehler",
      
      hero_ai_premium: "Verfügbar mit",
      
      // ComparePage - SmartRevision Workspace
      old_revision: "Alte Revision",
      new_revision: "Neue Revision",
      all_comparisons: "Alle Vergleiche",
      export_pdf: "PDF exportieren",
      differences: "Unterschiede",
      found: "gefunden",
      vector: "Vektor",
      opacity: "Deckkraft",
      start_smartrevision: "SmartRevision starten",
      legend: "Legende",
      legend_desc: "Unterschiede werden mit farbigen Kreisen/Ellipsen hervorgehoben, um die Originalwerte lesbar zu halten.",
      removed: "Entfernt",
      added: "Hinzugefügt",
      modified: "Geändert",
      removed_desc: "vorhanden in {oldRev}, fehlt in {newRev}",
      added_desc: "fehlt in {oldRev}, vorhanden in {newRev}",
      summary: "Zusammenfassung:",
      differences_list: "Unterschiede Liste",
      importance: "Wichtigkeit:",
      importance_high: "hoch",
      importance_medium: "mittel",
      importance_low: "niedrig",
      visual_diffs_detected: "Visuelle Unterschiede erkannt. Semantische Details nicht verfügbar.",
      upload_both_drawings: "Beide Zeichnungen hochladen",
      then_click: "dann klicken Sie auf",
      green_added: "Grün (Hinzugefügt)",
      red_removed: "Rot (Entfernt)",
      yellow_modified: "Gelb (Geändert)",
      diff_editor: "Unterschiede-Editor",
      add_note: "Notiz hinzufügen",
      add_circle: "Kreis hinzufügen",
      undo: "Rückgängig",
      save_changes: "Änderungen speichern",
      saved: "Gespeichert",
      delete_circle: "Kreis löschen",
      editor_instructions_line1: "Klick auf Kreis/Notiz zum Auswählen • Ziehen zum Bewegen • DEL zum Löschen",
      editor_instructions_line2: "Ecken ziehen zum Skalieren • Scrollen zum Zoomen • Ctrl+Z rückgängig",
      note_text_label: "Notiztext:",
      loading_high_res: "Hochauflösendes Bild wird geladen...",
      loading_high_res_desc: "Dies ermöglicht maximale Qualität für technische Zeichnungen",
      new_comparison_name: "Neuer Vergleich",
      guided_comparison_title: "Müssen Sie nur eine oder mehrere Ansichten der Zeichnung vergleichen?",
      guided_comparison_desc: "Verwenden Sie den geführten Ansichtsvergleich",
      guided_comparison_hint: "Verwenden Sie diesen Modus, wenn Ansichten zwischen Revisionen verschoben wurden",
      ai_credits_10: "Die Analyse kostet 10 AI-Credits.",
      differences_found: "Unterschiede gefunden:",
      zero_differences_title: "Keine Unterschiede gefunden",
      zero_differences_message: "Der automatische Vergleich hat 0 Unterschiede gefunden. Sind Sie sicher, dass es sich um dieselbe Zeichnung in verschiedenen Revisionen handelt?",
      zero_differences_hint: "Wenn ja, versuchen Sie den geführten Ansichtsvergleich, um bestimmte Bereiche manuell auszuwählen.",
      try_guided_comparison: "Geführten Vergleich versuchen",
      tutorial_upload_old: "Alte Revision hochladen",
      tutorial_upload_old_desc: "Laden Sie die Zeichnung der vorherigen Revision hoch (PDF oder Bild).",
      tutorial_upload_new: "Neue Revision hochladen",
      tutorial_upload_new_desc: "Laden Sie die Zeichnung der neuen Revision zum Vergleichen hoch.",
      tutorial_start_analysis: "Analyse starten",
      tutorial_start_analysis_desc: "Die KI erkennt automatisch die Unterschiede zwischen den beiden Revisionen.",
      tutorial_open_editor: "Editor öffnen",
      tutorial_open_editor_desc: "Überprüfen und bearbeiten Sie die Unterschiedsmarkierungen im Vollbildeditor.",
      user_circle: "(Benutzer)",
      new_note: "Neue Notiz",
      guided_results_title: "Ergebnisse des geführten Vergleichs",
      views_analyzed: "Ansichten analysiert",
      credits_consumed: "Verbrauchte Credits",
      no_differences: "Keine Unterschiede erkannt.",
      
      // Dashboard & Folders
      new_folder: "Neuer Ordner",
      folder_name: "Ordnername",
      folder_placeholder: "Z.B.: Kunden 2026",
      create_folder: "Ordner erstellen",
      rename_project: "Projekt umbenennen",
      move_to: "Verschieben nach",
      move_to_root: "In Root verschieben",
      no_description: "Keine Beschreibung",
      upload_logo: "Logo hochladen",
      upload_company_logo: "Laden Sie Ihr Firmenlogo hoch. Es wird in ISIR-Berichten verwendet.",
      logo_uploaded: "Firmenlogo hochgeladen!",
      logo_deleted: "Logo gelöscht",
      logo_only_images: "Nur Bilder sind erlaubt",
      logo_too_large: "Logo zu groß. Maximum 500KB",
      folder_created: "Ordner erstellt",
      folder_deleted: "Ordner gelöscht",
      project_renamed: "Projekt umbenannt",
      project_moved: "Projekt verschoben",
      confirm_delete_folder: "Diesen Ordner löschen? Projekte werden in Root verschoben.",
      confirm_delete_project: "Möchten Sie dieses Projekt wirklich löschen?",
      
      // SmartRevision Page
      smartrevision_page_title: "SmartRevision",
      smartrevision_page_subtitle: "Unterschiede zwischen Zeichnungen analysieren",
      new_comparison: "Neuer Vergleich",
      comparison_name: "Vergleichsname",
      comparison_description: "Beschreibung (optional)",
      create_comparison: "Vergleich erstellen",
      no_comparisons: "Keine Vergleiche",
      no_comparisons_desc: "Erstellen Sie Ihren ersten Vergleich, um Zeichnungsunterschiede zu analysieren",
      upgrade_to_ai: "Auf AI-Plan upgraden",
      starting_from: "Ab €99.99/Monat + MwSt. - 10 Credits pro Analyse",
      features_included: "Enthaltene Funktionen:",
      visual_comparison: "Automatischer visueller Vergleich",
      semantic_analysis: "Semantische Analyse mit KI",
      pdf_export_report: "PDF-Export mit detailliertem Bericht",
      save_comparisons: "Vergleiche speichern",
      credits_label: "Credits:",
      open_comparison: "Öffnen",
      delete_comparison: "Löschen",
      confirm_delete_comparison: "Möchten Sie diesen Vergleich wirklich löschen?",
      comparison_deleted: "Vergleich gelöscht",
      comparison_created: "Vergleich erstellt",
      
      // SmartRevision Status & UI
      status_completed: "Abgeschlossen",
      status_analyzing: "Wird analysiert...",
      status_failed: "Fehler",
      status_pending: "Ausstehend",
      credits_used: "Verwendete Credits:",
      no_folder: "Ohne Ordner",
      move_to_folder: "In Ordner verschieben",
      remove_from_folder: "Aus Ordner entfernen",
      vs: "vs",
      
      // GuidePage
      back: "Zurück",
      guide_title: "SmartBalloon Anleitung",
      print_save_pdf: "Drucken / Als PDF speichern",
      go_to_dashboard: "Zum Dashboard",
      table_of_contents: "INHALTSVERZEICHNIS",
      guide_intro: "Einführung",
      guide_upload: "1. Zeichnung hochladen",
      guide_views: "2. Ansichten definieren",
      guide_ai_detection: "3. KI-Erkennung",
      guide_markers: "4. Marker-Verwaltung",
      guide_cmm: "5. CMM-Import",
      guide_export: "6. Export",
      guide_smartrevision: "7. SmartRevision",
      guide_projects: "Projektverwaltung",
      guide_settings: "Einstellungen",
      guide_faq: "FAQ",
      guide_welcome_title: "Willkommen bei SmartBalloon",
      guide_suggestion: "Tipp:",
      
      // CMM Import Modal
      cmm_interpret_title: "Wie sollen die Berichte interpretiert werden?",
      cmm_interpret_desc: "Sie haben <strong>{count} CMM-Berichte</strong> hochgeladen. Wie sollen sie interpretiert werden?",
      cmm_mode_manual_title: "Ich weise Teile manuell zu",
      cmm_mode_manual_desc: "<strong>Sie wählen</strong>, welcher Bericht welchem Teil/Muster entspricht.",
      cmm_mode_manual_hint: "Sie können Teile umbenennen (z.B. \"Teil A\", \"Los 123\", etc.)",
      cmm_mode_multi_title: "Mehrere Proben (automatisch)",
      cmm_mode_multi_desc: "Jeder Bericht ist ein <strong>anderes Teil/Muster</strong>, automatische Nummerierung.",
      cmm_mode_multi_hint: "Bericht 1 → P1, Bericht 2 → P2, etc.",
      cmm_mode_duplicate_title: "Doppelte Berichte",
      cmm_mode_duplicate_desc: "Berichte enthalten <strong>Messungen desselben Teils</strong>.",
      cmm_mode_duplicate_hint: "Doppelte Maße werden zur manuellen Auswahl markiert.",
      cmm_continue: "Weiter",
      cmm_assign_title: "Berichte zu Teilen zuweisen",
      cmm_assign_desc: "Weisen Sie jedem Bericht einen Namen/Nummer zu. Dies identifiziert das Teil in den ISIR Excel-Spalten.",
      cmm_assign_placeholder: "Z.B.: P1, Teil A, Los 123",
      cmm_assign_tip: "Verwenden Sie kurze Namen, die als Spaltenüberschriften in Excel erscheinen (z.B. P1, P2, Los A, etc.)",
      cmm_continue_import: "Mit Import fortfahren",
      cmm_duplicate_title: "Doppeltes Maß - SB{id}",
      cmm_duplicate_desc: "Dieses Maß ist in mehreren Berichten vorhanden. Wählen Sie, welchen Wert Sie behalten möchten.",
      cmm_duplicate_count: "({current} von {total} Duplikaten)",
      cmm_duplicate_existing: "Vorhandener Marker:",
      cmm_duplicate_current: "(aktuell: {value})",
      cmm_duplicate_prev: "← Zurück",
      cmm_duplicate_next: "Weiter →",
      cmm_duplicate_confirm_all: "Alle bestätigen",
      
      // Manual Marker
      manual_marker: "Manueller Marker",
      manual_marker_desc: "Für Maße, die die KI nicht lesen kann (gedreht, unscharf), verwenden Sie \"Manueller Marker\".",
      manual_marker_warning: "Verwenden Sie manuellen Marker auch für geometrische Toleranzen (Ebenheit ⌂, Parallelität //, Zylindrizität ○, etc.)",
      manual_marker_insert: "Manuellen Marker einfügen",
    }
  },
  fr: {
    translation: {
      // Common
      app_name: "SmartBalloon",
      save: "Enregistrer",
      cancel: "Annuler",
      delete: "Supprimer",
      edit: "Modifier",
      close: "Fermer",
      confirm: "Confirmer",
      loading: "Chargement...",
      error: "Erreur",
      success: "Succès",
      guide: "Guide",
      
      // Auth
      login: "Connexion",
      register: "S'inscrire",
      logout: "Déconnexion",
      email: "Email",
      password: "Mot de passe",
      name: "Nom",
      forgot_password: "Mot de passe oublié?",
      no_account: "Pas de compte?",
      have_account: "Déjà un compte?",
      login_success: "Connexion réussie",
      register_success: "Inscription réussie",
      created_by_experience: "Créé à partir de l'expérience de",
      chat_bubble_message: "👋 Salut! Je suis DenAIs, écris-moi si tu as besoin!",
      chat_welcome_message: "Salut, je suis DenAIs, ton assistant. Écris-moi si tu as besoin d'aide!\n\n• Utilisation de l'app\n• Télécharger des dessins\n• Créer des marqueurs\n• Fonctions IA",
      denais_subtitle: "Ton assistant SmartBalloon",
      
      // Navigation
      dashboard: "Tableau de bord",
      projects: "Projets",
      subscription: "Abonnement",
      settings: "Paramètres",
      
      // Projects
      new_project: "Nouveau Projet",
      project_name: "Nom du Projet",
      project_description: "Description",
      create_project: "Créer le Projet",
      open_project: "Ouvrir",
      delete_project: "Supprimer le Projet",
      no_projects: "Aucun projet. Créez votre premier projet!",
      
      // Workspace
      upload_drawing: "Télécharger le Dessin",
      upload_logo: "Télécharger le Logo",
      drop_file: "Déposez le fichier ici ou cliquez pour parcourir",
      supported_formats: "Formats: PDF, PNG, JPG",
      
      // Tools
      select_tool: "Sélectionner",
      add_marker: "Ajouter Marqueur",
      zoom_in: "Zoom avant",
      zoom_out: "Zoom arrière",
      fit_to_screen: "Ajuster à l'écran",
      
      // Markers
      marker: "Marqueur",
      markers: "Marqueurs",
      description: "Description",
      nominal: "Nominal",
      tolerance_plus: "Tol +",
      tolerance_minus: "Tol -",
      measured_value: "Mesuré",
      instrument: "Instrument",
      resolution: "Résolution",
      result: "Résultat",
      ok: "OK",
      not_ok: "NON OK",
      
      // AI
      ai_detect: "Détection IA",
      ai_detecting: "Détection...",
      ai_premium_only: "La détection IA est disponible avec le plan AI Premium",
      ai_suggestions: "Suggestions IA",
      accept_all: "Tout accepter",
      reject_all: "Tout rejeter",
      
      // Export
      export: "Exporter",
      export_pdf: "Exporter PDF",
      export_excel: "Exporter ISIR Excel",
      exporting: "Exportation...",
      
      // Plans & Subscription Page
      free_plan: "Gratuit",
      pro_plan: "Professionnel",
      ai_plan: "AI Premium",
      current_plan: "Plan Actuel",
      upgrade: "Mettre à niveau",
      monthly: "mois",
      features: "Fonctionnalités",
      max_markers: "marqueurs maximum",
      unlimited_markers: "Marqueurs illimités",
      watermark: "Export avec filigrane",
      no_watermark: "Export complet (sans filigrane)",
      ai_detection: "Détection de dimensions IA",
      choose_your_plan: "Choisissez Votre Plan",
      unlock_potential: "Libérez tout le potentiel de SmartBalloon avec nos fonctionnalités premium",
      loading_plans: "Chargement des plans...",
      popular: "POPULAIRE",
      best_value: "MEILLEUR RAPPORT",
      your_plan: "VOTRE PLAN",
      plus_vat: "+ TVA",
      ai_plan_desc: "Détection IA par vues - 50 crédits/mois",
      ai_unlimited_desc: "IA Illimitée - scannez toutes les vues sans limites",
      markers_unlimited: "Marqueurs illimités",
      ai_view_detection: "Détection IA basée sur les vues",
      ai_credits_50: "50 crédits IA/mois (~12 vues)",
      credits_per_view: "~4 crédits par scan de vue",
      manual_clicks_free: "Clics IA manuels GRATUITS",
      full_export: "Export PDF & Excel complet",
      smartrevision_basic: "SmartRevision basique",
      everything_in_ai: "Tout inclus dans AI",
      unlimited_ai_credits: "Crédits IA ILLIMITÉS",
      unlimited_view_scans: "Scans de vues illimités",
      priority_support: "Support prioritaire",
      smartrevision_unlimited: "SmartRevision illimité",
      change_plan: "Changer de Plan",
      manage_subscription: "Gérer l'abonnement",
      manage_subscription_desc: "Annuler, mettre à jour le paiement, télécharger les factures",
      
      // Subscription cancelled
      subscription_cancelled: "Abonnement Annulé",
      subscription_cancelled_banner: "Votre abonnement a été annulé",
      subscription_access_until: "Vous aurez accès jusqu'au",
      subscription_days_remaining: "jours restants",
      subscription_day_remaining: "jour restant",
      subscription_expires_today: "L'abonnement expire aujourd'hui",
      subscription_reactivate: "Réactiver l'abonnement",
      subscription_cancelled_hint: "Votre plan passera à FREE après cette date",
      
      // Messages
      project_created: "Projet créé",
      project_deleted: "Projet supprimé",
      changes_saved: "Modifications enregistrées",
      upload_success: "Fichier téléchargé",
      export_started: "Exportation démarrée",
      marker_limit: "Limite de marqueurs atteinte. Passez à PRO pour des marqueurs illimités.",
      
      // Welcome popup
      welcome_title: "Bienvenue sur SmartBalloon!",
      welcome_subtitle: "Tout est prêt! Voici comment commencer:",
      welcome_step1_title: "Créer un nouveau projet",
      welcome_step1_desc: "Cliquez sur \"Nouveau Projet\"",
      welcome_step2_title: "Télécharger votre dessin",
      welcome_step2_desc: "Chargez un PDF ou une image à annoter",
      welcome_step3_title: "Placer vos repères",
      welcome_step3_desc: "Cliquez sur les cotes pour ajouter des marqueurs",
      welcome_button: "Compris, allons-y!",
      
      // Hero Section (Login Page)
      hero_title: "Gérez qualité et dessins techniques en quelques secondes",
      hero_subtitle: "De la création des ballons à la comparaison de révisions par IA",
      hero_step1: "Télécharger le dessin",
      hero_step2: "Détecter les cotes",
      hero_step3: "Comparer les révisions",
      
      // SmartBalloon Card
      smartballoon_title: "SmartBalloon",
      smartballoon_subtitle: "Créez des ballons, générez des rapports ISIR et gérez le contrôle qualité automatiquement",
      smartballoon_feature1: "Ballons automatiques par IA",
      smartballoon_feature2: "Génération de rapports ISIR",
      smartballoon_feature3: "Gestion complète des cotes",
      
      // SmartRevision Card
      smartrevision_headline: "Ne faites pas confiance qu'au cartouche.",
      smartrevision_subheadline: "Comparez deux révisions et découvrez chaque modification en secondes",
      smartrevision_title: "SmartRevision",
      smartrevision_subtitle: "Analysez les différences entre dessins et prévenez les erreurs de production",
      smartrevision_feature1: "Détection automatique des différences",
      smartrevision_feature2: "Mise en évidence des changements critiques",
      smartrevision_feature3: "Réduit les erreurs de production",
      
      hero_ai_premium: "Disponible avec",
      
      // ComparePage - SmartRevision Workspace
      old_revision: "Ancienne Révision",
      new_revision: "Nouvelle Révision",
      all_comparisons: "Toutes les comparaisons",
      export_pdf: "Exporter PDF",
      differences: "Différences",
      found: "trouvées",
      vector: "Vectoriel",
      opacity: "Opacité",
      start_smartrevision: "Lancer SmartRevision",
      legend: "Légende",
      legend_desc: "Les différences sont mises en évidence avec des cercles/ellipses colorés pour garder les valeurs d'origine lisibles.",
      removed: "Supprimé",
      added: "Ajouté",
      modified: "Modifié",
      removed_desc: "présent dans {oldRev}, absent dans {newRev}",
      added_desc: "absent dans {oldRev}, présent dans {newRev}",
      summary: "Résumé:",
      differences_list: "Liste des Différences",
      importance: "Importance:",
      importance_high: "haute",
      importance_medium: "moyenne",
      importance_low: "basse",
      visual_diffs_detected: "Différences visuelles détectées. Détails sémantiques non disponibles.",
      upload_both_drawings: "Téléchargez les deux dessins",
      then_click: "puis cliquez sur",
      green_added: "Vert (Ajouté)",
      red_removed: "Rouge (Supprimé)",
      yellow_modified: "Jaune (Modifié)",
      diff_editor: "Éditeur de Différences",
      add_note: "Ajouter une note",
      add_circle: "Ajouter un cercle",
      undo: "Annuler",
      save_changes: "Enregistrer les modifications",
      saved: "Enregistré",
      delete_circle: "Supprimer le cercle",
      editor_instructions_line1: "Cliquez sur cercle/note pour sélectionner • Glissez pour déplacer • DEL pour supprimer",
      editor_instructions_line2: "Glissez les coins pour redimensionner • Scroll pour zoomer • Ctrl+Z annuler",
      note_text_label: "Texte de la note:",
      loading_high_res: "Chargement de l'image haute résolution...",
      loading_high_res_desc: "Ceci permet la qualité maximale pour les dessins techniques",
      new_comparison_name: "Nouvelle comparaison",
      guided_comparison_title: "Besoin de comparer une ou plusieurs vues du dessin?",
      guided_comparison_desc: "Utilisez la Comparaison Guidée par Vue",
      guided_comparison_hint: "Utilisez ce mode lorsque les vues ont été déplacées entre les révisions",
      ai_credits_10: "L'analyse coûte 10 crédits AI.",
      differences_found: "Différences trouvées:",
      zero_differences_title: "Aucune différence trouvée",
      zero_differences_message: "La comparaison automatique a trouvé 0 différence. Êtes-vous sûr qu'il s'agit du même dessin en révisions différentes?",
      zero_differences_hint: "Si oui, essayez la Comparaison Guidée par Vue pour sélectionner manuellement des zones spécifiques à comparer.",
      try_guided_comparison: "Essayer la Comparaison Guidée",
      tutorial_upload_old: "Télécharger l'ancienne révision",
      tutorial_upload_old_desc: "Téléchargez le dessin de la révision précédente (PDF ou image).",
      tutorial_upload_new: "Télécharger la nouvelle révision",
      tutorial_upload_new_desc: "Téléchargez le dessin de la nouvelle révision à comparer.",
      tutorial_start_analysis: "Lancer l'analyse",
      tutorial_start_analysis_desc: "L'IA détectera automatiquement les différences entre les deux révisions.",
      tutorial_open_editor: "Ouvrir l'éditeur",
      tutorial_open_editor_desc: "Vérifiez et modifiez les marqueurs de différences dans l'éditeur plein écran.",
      user_circle: "(utilisateur)",
      new_note: "Nouvelle note",
      guided_results_title: "Résultats de la Comparaison Guidée",
      views_analyzed: "vues analysées",
      credits_consumed: "Crédits consommés",
      no_differences: "Aucune différence détectée.",
      
      // Dashboard & Folders
      new_folder: "Nouveau Dossier",
      folder_name: "Nom du Dossier",
      folder_placeholder: "Ex: Clients 2026",
      create_folder: "Créer le Dossier",
      rename_project: "Renommer le Projet",
      move_to: "Déplacer vers",
      move_to_root: "Déplacer à la racine",
      no_description: "Aucune description",
      upload_logo: "Télécharger Logo",
      upload_company_logo: "Téléchargez votre logo d'entreprise. Il sera utilisé dans les rapports ISIR.",
      logo_uploaded: "Logo d'entreprise téléchargé!",
      logo_deleted: "Logo supprimé",
      logo_only_images: "Seules les images sont autorisées",
      logo_too_large: "Logo trop volumineux. Maximum 500KB",
      folder_created: "Dossier créé",
      folder_deleted: "Dossier supprimé",
      project_renamed: "Projet renommé",
      project_moved: "Projet déplacé",
      confirm_delete_folder: "Supprimer ce dossier? Les projets seront déplacés à la racine.",
      confirm_delete_project: "Êtes-vous sûr de vouloir supprimer ce projet?",
      
      // SmartRevision Page
      smartrevision_page_title: "SmartRevision",
      smartrevision_page_subtitle: "Analysez les différences entre dessins",
      new_comparison: "Nouvelle Comparaison",
      comparison_name: "Nom de la Comparaison",
      comparison_description: "Description (optionnelle)",
      create_comparison: "Créer la Comparaison",
      no_comparisons: "Aucune comparaison",
      no_comparisons_desc: "Créez votre première comparaison pour analyser les différences de dessins",
      upgrade_to_ai: "Passer au Plan AI",
      starting_from: "À partir de €99.99/mois + TVA - 10 crédits par analyse",
      features_included: "Fonctionnalités incluses:",
      visual_comparison: "Comparaison visuelle automatique",
      semantic_analysis: "Analyse sémantique avec IA",
      pdf_export_report: "Export PDF avec rapport détaillé",
      save_comparisons: "Sauvegarde des comparaisons",
      credits_label: "Crédits:",
      open_comparison: "Ouvrir",
      delete_comparison: "Supprimer",
      confirm_delete_comparison: "Êtes-vous sûr de vouloir supprimer cette comparaison?",
      comparison_deleted: "Comparaison supprimée",
      comparison_created: "Comparaison créée",
      
      // SmartRevision Status & UI
      status_completed: "Terminée",
      status_analyzing: "Analyse en cours...",
      status_failed: "Erreur",
      status_pending: "En attente",
      credits_used: "Crédits utilisés:",
      no_folder: "Sans dossier",
      move_to_folder: "Déplacer dans un dossier",
      remove_from_folder: "Retirer du dossier",
      vs: "vs",
      
      // GuidePage
      back: "Retour",
      guide_title: "Guide SmartBalloon",
      print_save_pdf: "Imprimer / Enregistrer PDF",
      go_to_dashboard: "Aller au tableau de bord",
      table_of_contents: "SOMMAIRE",
      guide_intro: "Introduction",
      guide_upload: "1. Télécharger le dessin",
      guide_views: "2. Définir les vues",
      guide_ai_detection: "3. Détection IA",
      guide_markers: "4. Gestion des marqueurs",
      guide_cmm: "5. Import CMM",
      guide_export: "6. Export",
      guide_smartrevision: "7. SmartRevision",
      guide_projects: "Gestion des projets",
      guide_settings: "Paramètres",
      guide_faq: "FAQ",
      guide_welcome_title: "Bienvenue sur SmartBalloon",
      guide_suggestion: "Conseil:",
      
      // CMM Import Modal
      cmm_interpret_title: "Comment interpréter les rapports?",
      cmm_interpret_desc: "Vous avez téléchargé <strong>{count} rapports CMM</strong>. Comment doivent-ils être interprétés?",
      cmm_mode_manual_title: "J'assigne les pièces manuellement",
      cmm_mode_manual_desc: "<strong>Vous choisissez</strong> quel rapport correspond à quelle pièce/échantillon.",
      cmm_mode_manual_hint: "Vous pouvez renommer les pièces (ex: \"Pièce A\", \"Lot 123\", etc.)",
      cmm_mode_multi_title: "Échantillons multiples (automatique)",
      cmm_mode_multi_desc: "Chaque rapport est une <strong>pièce/échantillon différent</strong>, numérotation automatique.",
      cmm_mode_multi_hint: "Rapport 1 → P1, Rapport 2 → P2, etc.",
      cmm_mode_duplicate_title: "Rapports en double",
      cmm_mode_duplicate_desc: "Les rapports contiennent <strong>des mesures de la même pièce</strong>.",
      cmm_mode_duplicate_hint: "Les cotes en double seront signalées pour sélection manuelle.",
      cmm_continue: "Continuer",
      cmm_assign_title: "Assigner les rapports aux pièces",
      cmm_assign_desc: "Assignez un nom/numéro à chaque rapport. Ceci identifiera la pièce dans les colonnes Excel ISIR.",
      cmm_assign_placeholder: "Ex: P1, Pièce A, Lot 123",
      cmm_assign_tip: "Utilisez des noms courts qui apparaîtront comme en-têtes de colonnes dans Excel (ex: P1, P2, Lot A, etc.)",
      cmm_continue_import: "Continuer avec l'import",
      cmm_duplicate_title: "Cote en double - SB{id}",
      cmm_duplicate_desc: "Cette cote est présente dans plusieurs rapports. Sélectionnez quelle valeur conserver.",
      cmm_duplicate_count: "({current} sur {total} doublons)",
      cmm_duplicate_existing: "Marqueur existant:",
      cmm_duplicate_current: "(actuel: {value})",
      cmm_duplicate_prev: "← Retour",
      cmm_duplicate_next: "Suivant →",
      cmm_duplicate_confirm_all: "Tout confirmer",
      
      // Manual Marker
      manual_marker: "Marqueur manuel",
      manual_marker_desc: "Pour les cotes que l'IA ne peut pas lire (tournées, floues), utilisez \"Marqueur manuel\".",
      manual_marker_warning: "Utilisez aussi le marqueur manuel pour les tolérances géométriques (planéité ⌂, parallélisme //, cylindricité ○, etc.)",
      manual_marker_insert: "Insertion marqueur manuel",
    }
  },
  zh: {
    translation: {
      // Common
      app_name: "SmartBalloon",
      save: "保存",
      cancel: "取消",
      delete: "删除",
      edit: "编辑",
      close: "关闭",
      confirm: "确认",
      loading: "加载中...",
      error: "错误",
      success: "成功",
      
      // Auth
      login: "登录",
      register: "注册",
      logout: "退出",
      email: "电子邮箱",
      password: "密码",
      name: "姓名",
      forgot_password: "忘记密码？",
      no_account: "没有账户？",
      have_account: "已有账户？",
      login_success: "登录成功",
      register_success: "注册成功",
      created_by_experience: "基于以下公司的经验创建",
      chat_bubble_message: "👋 需要帮助吗？问我！",
      chat_welcome_message: "你好！我是SmartBalloon助手。有什么可以帮您的？\n\n• 如何使用应用\n• 上传图纸\n• 创建标记\n• AI功能",
      
      // Navigation
      dashboard: "仪表板",
      projects: "项目",
      subscription: "订阅",
      settings: "设置",
      
      // Projects
      new_project: "新建项目",
      project_name: "项目名称",
      project_description: "描述",
      create_project: "创建项目",
      open_project: "打开",
      delete_project: "删除项目",
      no_projects: "暂无项目。创建您的第一个项目！",
      
      // Workspace
      upload_drawing: "上传图纸",
      upload_logo: "上传标志",
      drop_file: "拖放文件到此处或点击浏览",
      supported_formats: "支持格式：PDF、PNG、JPG",
      
      // Tools
      select_tool: "选择",
      add_marker: "添加标记",
      zoom_in: "放大",
      zoom_out: "缩小",
      fit_to_screen: "适应屏幕",
      
      // Markers
      marker: "标记",
      markers: "标记",
      description: "图纸尺寸",
      nominal: "标称值",
      tolerance_plus: "上公差",
      tolerance_minus: "下公差",
      measured_value: "测量值",
      instrument: "仪器",
      resolution: "分辨率",
      result: "结果",
      ok: "合格",
      not_ok: "不合格",
      
      // AI
      ai_detect: "AI智能识别",
      ai_detecting: "识别中...",
      ai_premium_only: "AI识别功能需要AI高级版",
      ai_suggestions: "AI建议",
      accept_all: "全部接受",
      reject_all: "全部拒绝",
      
      // Export
      export: "导出",
      export_pdf: "导出PDF",
      export_excel: "导出ISIR Excel",
      exporting: "导出中...",
      
      // Plans
      free_plan: "免费版",
      pro_plan: "专业版",
      ai_plan: "AI高级版",
      current_plan: "当前套餐",
      upgrade: "升级",
      monthly: "每月",
      features: "功能",
      max_markers: "最多标记数",
      unlimited_markers: "无限标记",
      watermark: "导出带水印",
      no_watermark: "完整导出（无水印）",
      ai_detection: "AI尺寸检测",
      
      // Subscription cancelled
      subscription_cancelled: "订阅已取消",
      subscription_cancelled_banner: "您的订阅已被取消",
      subscription_access_until: "您将继续拥有访问权限直到",
      subscription_days_remaining: "天剩余",
      subscription_day_remaining: "天剩余",
      subscription_expires_today: "订阅今天到期",
      subscription_reactivate: "重新激活订阅",
      subscription_cancelled_hint: "此日期后您的计划将降级为FREE",
      
      // Messages
      project_created: "项目已创建",
      project_deleted: "项目已删除",
      changes_saved: "更改已保存",
      upload_success: "文件已上传",
      export_started: "开始导出",
      marker_limit: "标记数量已达上限。升级PRO版获取无限标记。",
      
      // Welcome popup
      welcome_title: "欢迎使用SmartBalloon！",
      welcome_subtitle: "一切就绪！以下是开始步骤：",
      welcome_step1_title: "创建新项目",
      welcome_step1_desc: "点击\"新建项目\"开始",
      welcome_step2_title: "上传图纸",
      welcome_step2_desc: "加载PDF或图片进行标注",
      welcome_step3_title: "放置标记",
      welcome_step3_desc: "点击尺寸添加标记",
      welcome_button: "明白了，开始吧！",
      
      // Hero Section (Login Page)
      hero_title: "秒速管理质量和技术图纸",
      hero_subtitle: "从创建气球标注到AI驱动的版本对比",
      hero_step1: "上传图纸",
      hero_step2: "检测尺寸",
      hero_step3: "对比版本",
      
      // SmartBalloon Card
      smartballoon_title: "SmartBalloon",
      smartballoon_subtitle: "自动创建气球标注、生成ISIR报告并管理质量控制",
      smartballoon_feature1: "AI自动标注",
      smartballoon_feature2: "ISIR报告生成",
      smartballoon_feature3: "完整的尺寸管理",
      
      // SmartRevision Card
      smartrevision_headline: "不要只相信标题栏。",
      smartrevision_subheadline: "比较两个版本，秒速发现每一处修改",
      smartrevision_title: "SmartRevision",
      smartrevision_subtitle: "分析图纸差异，预防生产错误",
      smartrevision_feature1: "自动检测差异",
      smartrevision_feature2: "突出显示关键更改",
      smartrevision_feature3: "减少生产错误",
      
      hero_ai_premium: "可用于",
      guide: "指南",
      
      // ComparePage - SmartRevision Workspace
      old_revision: "旧版本",
      new_revision: "新版本",
      all_comparisons: "所有比较",
      export_pdf: "导出PDF",
      differences: "差异",
      found: "已找到",
      vector: "矢量",
      opacity: "不透明度",
      start_smartrevision: "启动SmartRevision",
      legend: "图例",
      legend_desc: "差异用彩色圆圈/椭圆突出显示，以保持原始值的可读性。",
      removed: "已删除",
      added: "已添加",
      modified: "已修改",
      removed_desc: "存在于{oldRev}，不存在于{newRev}",
      added_desc: "不存在于{oldRev}，存在于{newRev}",
      summary: "摘要：",
      differences_list: "差异列表",
      importance: "重要性：",
      importance_high: "高",
      importance_medium: "中",
      importance_low: "低",
      visual_diffs_detected: "检测到视觉差异。语义详情不可用。",
      upload_both_drawings: "上传两张图纸",
      then_click: "然后点击",
      green_added: "绿色（已添加）",
      red_removed: "红色（已删除）",
      yellow_modified: "黄色（已修改）",
      diff_editor: "差异编辑器",
      add_note: "添加笔记",
      add_circle: "添加圆圈",
      undo: "撤销",
      save_changes: "保存更改",
      saved: "已保存",
      delete_circle: "删除圆圈",
      editor_instructions_line1: "点击圆圈/笔记选择 • 拖动移动 • DEL删除",
      editor_instructions_line2: "拖动角落调整大小 • 滚动缩放 • Ctrl+Z撤销",
      note_text_label: "笔记文本：",
      loading_high_res: "正在加载高分辨率图像...",
      loading_high_res_desc: "这为技术图纸提供最高质量",
      new_comparison_name: "新比较",
      guided_comparison_title: "只需要比较图纸的一个或多个视图？",
      guided_comparison_desc: "使用引导式视图比较",
      guided_comparison_hint: "当视图在版本之间移动时使用此模式",
      ai_credits_10: "分析需要10个AI积分。",
      differences_found: "找到差异：",
      zero_differences_title: "未找到差异",
      zero_differences_message: "自动比较未找到差异。您确定这是同一图纸的不同版本吗？",
      zero_differences_hint: "如果是，请尝试使用引导视图比较来手动选择要比较的特定区域。",
      try_guided_comparison: "尝试引导比较",
      tutorial_upload_old: "上传旧版本",
      tutorial_upload_old_desc: "上传上一个版本的图纸（PDF或图片）。",
      tutorial_upload_new: "上传新版本",
      tutorial_upload_new_desc: "上传要比较的新版本图纸。",
      tutorial_start_analysis: "开始分析",
      tutorial_start_analysis_desc: "AI将自动检测两个版本之间的差异。",
      tutorial_open_editor: "打开编辑器",
      tutorial_open_editor_desc: "在全屏编辑器中检查和编辑差异标记。",
      user_circle: "（用户）",
      new_note: "新笔记",
      guided_results_title: "引导比较结果",
      views_analyzed: "已分析视图",
      credits_consumed: "已消耗积分",
      no_differences: "未检测到差异。",
      
      // Dashboard & Folders
      new_folder: "新建文件夹",
      folder_name: "文件夹名称",
      folder_placeholder: "例如：客户2026",
      create_folder: "创建文件夹",
      rename_project: "重命名项目",
      move_to: "移动到",
      move_to_root: "移动到根目录",
      no_description: "无描述",
      upload_company_logo: "上传您的公司标志。它将用于ISIR报告。",
      logo_uploaded: "公司标志已上传！",
      logo_deleted: "标志已删除",
      logo_only_images: "只允许图片",
      logo_too_large: "标志太大。最大500KB",
      folder_created: "文件夹已创建",
      folder_deleted: "文件夹已删除",
      project_renamed: "项目已重命名",
      project_moved: "项目已移动",
      confirm_delete_folder: "删除此文件夹？项目将被移至根目录。",
      confirm_delete_project: "确定要删除此项目吗？",
      
      // SmartRevision Page
      smartrevision_page_title: "SmartRevision",
      smartrevision_page_subtitle: "分析图纸差异",
      new_comparison: "新建比较",
      comparison_name: "比较名称",
      comparison_description: "描述（可选）",
      create_comparison: "创建比较",
      no_comparisons: "暂无比较",
      no_comparisons_desc: "创建您的第一个比较以分析图纸差异",
      upgrade_to_ai: "升级到AI计划",
      starting_from: "起价€99.99/月 + 增值税 - 每次分析10个积分",
      features_included: "包含功能：",
      visual_comparison: "自动视觉比较",
      semantic_analysis: "AI语义分析",
      pdf_export_report: "PDF导出详细报告",
      save_comparisons: "保存比较",
      credits_label: "积分：",
      open_comparison: "打开",
      delete_comparison: "删除",
      confirm_delete_comparison: "确定要删除此比较吗？",
      comparison_deleted: "比较已删除",
      comparison_created: "比较已创建",
      
      // SmartRevision Status & UI
      status_completed: "已完成",
      status_analyzing: "分析中...",
      status_failed: "错误",
      status_pending: "待处理",
      credits_used: "已用积分：",
      no_folder: "无文件夹",
      move_to_folder: "移至文件夹",
      remove_from_folder: "从文件夹移除",
      vs: "vs",
      
      // Subscription
      manage_subscription: "管理订阅",
      manage_subscription_desc: "取消、更新付款、下载发票",
      
      // GuidePage
      back: "返回",
      guide_title: "SmartBalloon指南",
      print_save_pdf: "打印/保存PDF",
      go_to_dashboard: "转到仪表板",
      table_of_contents: "目录",
      guide_intro: "简介",
      guide_upload: "1. 上传图纸",
      guide_views: "2. 定义视图",
      guide_ai_detection: "3. AI检测",
      guide_markers: "4. 标记管理",
      guide_cmm: "5. CMM导入",
      guide_export: "6. 导出",
      guide_smartrevision: "7. SmartRevision",
      guide_projects: "项目管理",
      guide_settings: "设置",
      guide_faq: "常见问题",
      guide_welcome_title: "欢迎使用SmartBalloon",
      guide_suggestion: "建议：",
      
      // CMM Import Modal
      cmm_interpret_title: "如何解析报告？",
      cmm_interpret_desc: "您已上传<strong>{count}份CMM报告</strong>。应如何解析？",
      cmm_mode_manual_title: "手动分配零件",
      cmm_mode_manual_desc: "<strong>您选择</strong>哪个报告对应哪个零件/样品。",
      cmm_mode_manual_hint: "您可以重命名零件（如：\"零件A\"、\"批次123\"等）",
      cmm_mode_multi_title: "多样品（自动）",
      cmm_mode_multi_desc: "每个报告是<strong>不同的零件/样品</strong>，自动编号。",
      cmm_mode_multi_hint: "报告1 → P1，报告2 → P2等",
      cmm_mode_duplicate_title: "重复报告",
      cmm_mode_duplicate_desc: "报告包含<strong>同一零件的测量值</strong>。",
      cmm_mode_duplicate_hint: "重复尺寸将标记为手动选择。",
      cmm_continue: "继续",
      cmm_assign_title: "将报告分配给零件",
      cmm_assign_desc: "为每个报告分配名称/编号。这将识别ISIR Excel列中的零件。",
      cmm_assign_placeholder: "例如：P1、零件A、批次123",
      cmm_assign_tip: "使用将在Excel中显示为列标题的短名称（如P1、P2、批次A等）",
      cmm_continue_import: "继续导入",
      cmm_duplicate_title: "重复尺寸 - SB{id}",
      cmm_duplicate_desc: "此尺寸存在于多个报告中。选择要保留的值。",
      cmm_duplicate_count: "（{current}/{total}个重复）",
      cmm_duplicate_existing: "现有标记：",
      cmm_duplicate_current: "（当前：{value}）",
      cmm_duplicate_prev: "← 返回",
      cmm_duplicate_next: "下一步 →",
      cmm_duplicate_confirm_all: "确认全部",
      
      // Manual Marker
      manual_marker: "手动标记",
      manual_marker_desc: "对于AI无法读取的尺寸（旋转、模糊），请使用\"手动标记\"。",
      manual_marker_warning: "对于几何公差（平面度⌂、平行度//、圆柱度○等）也请使用手动标记",
      manual_marker_insert: "手动标记输入",
    }
  },
  hi: {
    translation: {
      // Common
      app_name: "SmartBalloon",
      save: "सहेजें",
      cancel: "रद्द करें",
      delete: "हटाएं",
      edit: "संपादित करें",
      close: "बंद करें",
      confirm: "पुष्टि करें",
      loading: "लोड हो रहा है...",
      error: "त्रुटि",
      success: "सफल",
      
      // Auth
      login: "लॉगिन",
      register: "पंजीकरण",
      logout: "लॉगआउट",
      email: "ईमेल",
      password: "पासवर्ड",
      name: "नाम",
      forgot_password: "पासवर्ड भूल गए?",
      no_account: "खाता नहीं है?",
      have_account: "पहले से खाता है?",
      login_success: "लॉगिन सफल",
      register_success: "पंजीकरण सफल",
      
      // Navigation
      dashboard: "डैशबोर्ड",
      projects: "प्रोजेक्ट",
      subscription: "सदस्यता",
      settings: "सेटिंग्स",
      
      // Projects
      new_project: "नया प्रोजेक्ट",
      project_name: "प्रोजेक्ट का नाम",
      project_description: "विवरण",
      create_project: "प्रोजेक्ट बनाएं",
      open_project: "खोलें",
      delete_project: "प्रोजेक्ट हटाएं",
      no_projects: "कोई प्रोजेक्ट नहीं। अपना पहला प्रोजेक्ट बनाएं!",
      
      // Workspace
      upload_drawing: "ड्राइंग अपलोड करें",
      upload_logo: "लोगो अपलोड करें",
      drop_file: "फ़ाइल यहां छोड़ें या ब्राउज़ करने के लिए क्लिक करें",
      supported_formats: "समर्थित: PDF, PNG, JPG",
      
      // Tools
      select_tool: "चयन करें",
      add_marker: "मार्कर जोड़ें",
      zoom_in: "ज़ूम इन",
      zoom_out: "ज़ूम आउट",
      fit_to_screen: "स्क्रीन पर फिट करें",
      
      // Markers
      marker: "मार्कर",
      markers: "मार्कर",
      description: "ड्राइंग आयाम",
      nominal: "नाममात्र",
      tolerance_plus: "ऊपरी सहनशीलता",
      tolerance_minus: "निचली सहनशीलता",
      measured_value: "मापा गया",
      instrument: "उपकरण",
      resolution: "संकल्प",
      result: "परिणाम",
      ok: "ठीक है",
      not_ok: "ठीक नहीं",
      
      // AI
      ai_detect: "AI पहचान",
      ai_detecting: "पहचान हो रही है...",
      ai_premium_only: "AI पहचान AI प्रीमियम योजना के साथ उपलब्ध है",
      ai_suggestions: "AI सुझाव",
      accept_all: "सभी स्वीकार करें",
      reject_all: "सभी अस्वीकार करें",
      
      // Export
      export: "निर्यात करें",
      export_pdf: "PDF निर्यात करें",
      export_excel: "ISIR Excel निर्यात करें",
      exporting: "निर्यात हो रहा है...",
      
      // Plans
      free_plan: "मुफ्त",
      pro_plan: "पेशेवर",
      ai_plan: "AI प्रीमियम",
      current_plan: "वर्तमान योजना",
      upgrade: "अपग्रेड करें",
      monthly: "मासिक",
      features: "विशेषताएं",
      max_markers: "अधिकतम मार्कर",
      unlimited_markers: "असीमित मार्कर",
      watermark: "वॉटरमार्क के साथ निर्यात",
      no_watermark: "पूर्ण निर्यात (बिना वॉटरमार्क)",
      ai_detection: "AI आयाम पहचान",
      
      // Subscription cancelled
      subscription_cancelled: "सदस्यता रद्द",
      subscription_cancelled_banner: "आपकी सदस्यता रद्द कर दी गई है",
      subscription_access_until: "आपकी पहुंच जारी रहेगी",
      subscription_days_remaining: "दिन शेष",
      subscription_day_remaining: "दिन शेष",
      subscription_expires_today: "सदस्यता आज समाप्त होती है",
      subscription_reactivate: "सदस्यता पुनः सक्रिय करें",
      subscription_cancelled_hint: "इस तारीख के बाद आपका प्लान FREE हो जाएगा",
      
      // Messages
      project_created: "प्रोजेक्ट बनाया गया",
      project_deleted: "प्रोजेक्ट हटाया गया",
      changes_saved: "परिवर्तन सहेजे गए",
      upload_success: "फ़ाइल अपलोड की गई",
      export_started: "निर्यात शुरू हुआ",
      marker_limit: "मार्कर सीमा पूरी हो गई। असीमित मार्कर के लिए PRO में अपग्रेड करें।",
      
      // Welcome popup
      welcome_title: "SmartBalloon में आपका स्वागत है!",
      welcome_subtitle: "सब तैयार है! यहां बताया गया है कि कैसे शुरू करें:",
      welcome_step1_title: "नया प्रोजेक्ट बनाएं",
      welcome_step1_desc: "शुरू करने के लिए \"नया प्रोजेक्ट\" पर क्लिक करें",
      welcome_step2_title: "अपना ड्राइंग अपलोड करें",
      welcome_step2_desc: "मार्क करने के लिए PDF या इमेज लोड करें",
      welcome_step3_title: "मार्कर लगाएं",
      welcome_step3_desc: "मार्कर जोड़ने के लिए आयामों पर क्लिक करें",
      welcome_button: "समझ गया, चलो शुरू करें!",
      
      // Hero Section (Login Page)
      hero_title: "सेकंडों में गुणवत्ता और तकनीकी चित्र प्रबंधित करें",
      hero_subtitle: "बैलून निर्माण से AI-संचालित संशोधन तुलना तक",
      hero_step1: "ड्राइंग अपलोड करें",
      hero_step2: "आयाम पहचानें",
      hero_step3: "संशोधन तुलना करें",
      
      // SmartBalloon Card
      smartballoon_title: "SmartBalloon",
      smartballoon_subtitle: "स्वचालित रूप से बैलून बनाएं, ISIR रिपोर्ट जनरेट करें और गुणवत्ता नियंत्रण प्रबंधित करें",
      smartballoon_feature1: "AI स्वचालित बैलून",
      smartballoon_feature2: "ISIR रिपोर्ट जनरेशन",
      smartballoon_feature3: "पूर्ण आयाम प्रबंधन",
      
      // SmartRevision Card
      smartrevision_headline: "केवल टाइटल ब्लॉक पर भरोसा न करें।",
      smartrevision_subheadline: "दो संशोधनों की तुलना करें और सेकंडों में हर बदलाव खोजें",
      smartrevision_title: "SmartRevision",
      smartrevision_subtitle: "ड्राइंग में अंतर का विश्लेषण करें और उत्पादन त्रुटियों को रोकें",
      smartrevision_feature1: "स्वचालित अंतर पहचान",
      smartrevision_feature2: "महत्वपूर्ण परिवर्तन हाइलाइट करें",
      smartrevision_feature3: "उत्पादन त्रुटियां कम करता है",
      
      hero_ai_premium: "उपलब्ध है",
      guide: "गाइड",
      
      // ComparePage - SmartRevision Workspace
      old_revision: "पुराना संस्करण",
      new_revision: "नया संस्करण",
      all_comparisons: "सभी तुलनाएं",
      export_pdf: "PDF निर्यात करें",
      differences: "अंतर",
      found: "मिले",
      vector: "वेक्टर",
      opacity: "अपारदर्शिता",
      start_smartrevision: "SmartRevision शुरू करें",
      legend: "किंवदंती",
      legend_desc: "मूल मानों को पठनीय रखने के लिए अंतर रंगीन वृत्तों/दीर्घवृत्तों से उजागर किए जाते हैं।",
      removed: "हटाया गया",
      added: "जोड़ा गया",
      modified: "संशोधित",
      removed_desc: "{oldRev} में मौजूद, {newRev} में अनुपस्थित",
      added_desc: "{oldRev} में अनुपस्थित, {newRev} में मौजूद",
      summary: "सारांश:",
      differences_list: "अंतर सूची",
      importance: "महत्व:",
      importance_high: "उच्च",
      importance_medium: "मध्यम",
      importance_low: "निम्न",
      visual_diffs_detected: "दृश्य अंतर पाए गए। सिमेंटिक विवरण उपलब्ध नहीं।",
      upload_both_drawings: "दोनों चित्र अपलोड करें",
      then_click: "फिर क्लिक करें",
      green_added: "हरा (जोड़ा गया)",
      red_removed: "लाल (हटाया गया)",
      yellow_modified: "पीला (संशोधित)",
      diff_editor: "अंतर संपादक",
      add_note: "नोट जोड़ें",
      add_circle: "वृत्त जोड़ें",
      undo: "पूर्ववत करें",
      save_changes: "परिवर्तन सहेजें",
      saved: "सहेजा गया",
      delete_circle: "वृत्त हटाएं",
      editor_instructions_line1: "चयन करने के लिए वृत्त/नोट पर क्लिक करें • खींचें • DEL हटाने के लिए",
      editor_instructions_line2: "आकार बदलने के लिए कोने खींचें • ज़ूम के लिए स्क्रॉल • Ctrl+Z पूर्ववत",
      note_text_label: "नोट पाठ:",
      loading_high_res: "उच्च रिज़ॉल्यूशन छवि लोड हो रही है...",
      loading_high_res_desc: "यह तकनीकी चित्रों के लिए अधिकतम गुणवत्ता प्रदान करता है",
      new_comparison_name: "नई तुलना",
      guided_comparison_title: "केवल एक या अधिक दृश्यों की तुलना करनी है?",
      guided_comparison_desc: "गाइडेड व्यू तुलना का उपयोग करें",
      guided_comparison_hint: "इस मोड का उपयोग करें जब दृश्य संशोधनों के बीच स्थानांतरित हो गए हों",
      ai_credits_10: "विश्लेषण में 10 AI क्रेडिट खर्च होते हैं।",
      differences_found: "अंतर मिले:",
      zero_differences_title: "कोई अंतर नहीं मिला",
      zero_differences_message: "स्वचालित तुलना में 0 अंतर पाए गए। क्या आप सुनिश्चित हैं कि यह एक ही चित्र के विभिन्न संस्करण हैं?",
      zero_differences_hint: "यदि हां, तो विशिष्ट क्षेत्रों को मैन्युअल रूप से चुनने के लिए गाइडेड व्यू तुलना आज़माएं।",
      try_guided_comparison: "गाइडेड तुलना आज़माएं",
      tutorial_upload_old: "पुराना संस्करण अपलोड करें",
      tutorial_upload_old_desc: "पिछले संस्करण का चित्र अपलोड करें (PDF या छवि)।",
      tutorial_upload_new: "नया संस्करण अपलोड करें",
      tutorial_upload_new_desc: "तुलना के लिए नए संस्करण का चित्र अपलोड करें।",
      tutorial_start_analysis: "विश्लेषण शुरू करें",
      tutorial_start_analysis_desc: "AI स्वचालित रूप से दो संस्करणों के बीच अंतर का पता लगाएगा।",
      tutorial_open_editor: "संपादक खोलें",
      tutorial_open_editor_desc: "फुलस्क्रीन संपादक में अंतर मार्कर जांचें और संपादित करें।",
      user_circle: "(उपयोगकर्ता)",
      new_note: "नई टिप्पणी",
      guided_results_title: "गाइडेड तुलना परिणाम",
      views_analyzed: "विश्लेषित दृश्य",
      credits_consumed: "खर्च किए गए क्रेडिट",
      no_differences: "कोई अंतर नहीं मिला।",
      
      // Dashboard & Folders
      new_folder: "नया फ़ोल्डर",
      folder_name: "फ़ोल्डर का नाम",
      folder_placeholder: "उदा: ग्राहक 2026",
      create_folder: "फ़ोल्डर बनाएं",
      rename_project: "प्रोजेक्ट का नाम बदलें",
      move_to: "यहां ले जाएं",
      move_to_root: "रूट में ले जाएं",
      no_description: "कोई विवरण नहीं",
      upload_company_logo: "अपनी कंपनी का लोगो अपलोड करें। यह ISIR रिपोर्ट में उपयोग होगा।",
      logo_uploaded: "कंपनी लोगो अपलोड हो गया!",
      logo_deleted: "लोगो हटा दिया गया",
      logo_only_images: "केवल चित्र अनुमत हैं",
      logo_too_large: "लोगो बहुत बड़ा है। अधिकतम 500KB",
      folder_created: "फ़ोल्डर बना",
      folder_deleted: "फ़ोल्डर हटाया गया",
      project_renamed: "प्रोजेक्ट का नाम बदला गया",
      project_moved: "प्रोजेक्ट स्थानांतरित",
      confirm_delete_folder: "यह फ़ोल्डर हटाएं? प्रोजेक्ट रूट में जाएंगे।",
      confirm_delete_project: "क्या आप वाकई इस प्रोजेक्ट को हटाना चाहते हैं?",
      
      // SmartRevision Page
      smartrevision_page_title: "SmartRevision",
      smartrevision_page_subtitle: "ड्राइंग में अंतर का विश्लेषण करें",
      new_comparison: "नई तुलना",
      comparison_name: "तुलना का नाम",
      comparison_description: "विवरण (वैकल्पिक)",
      create_comparison: "तुलना बनाएं",
      no_comparisons: "कोई तुलना नहीं",
      no_comparisons_desc: "ड्राइंग अंतर का विश्लेषण करने के लिए अपनी पहली तुलना बनाएं",
      upgrade_to_ai: "AI योजना में अपग्रेड करें",
      starting_from: "€99.99/माह + कर से शुरू - प्रति विश्लेषण 10 क्रेडिट",
      features_included: "शामिल सुविधाएं:",
      visual_comparison: "स्वचालित दृश्य तुलना",
      semantic_analysis: "AI के साथ सिमेंटिक विश्लेषण",
      pdf_export_report: "विस्तृत रिपोर्ट के साथ PDF निर्यात",
      save_comparisons: "तुलनाएं सहेजें",
      credits_label: "क्रेडिट:",
      open_comparison: "खोलें",
      delete_comparison: "हटाएं",
      confirm_delete_comparison: "क्या आप वाकई इस तुलना को हटाना चाहते हैं?",
      comparison_deleted: "तुलना हटाई गई",
      comparison_created: "तुलना बनाई गई",
      
      // SmartRevision Status & UI
      status_completed: "पूर्ण",
      status_analyzing: "विश्लेषण हो रहा है...",
      status_failed: "त्रुटि",
      status_pending: "लंबित",
      credits_used: "उपयोग किए गए क्रेडिट:",
      no_folder: "कोई फ़ोल्डर नहीं",
      move_to_folder: "फ़ोल्डर में ले जाएं",
      remove_from_folder: "फ़ोल्डर से हटाएं",
      vs: "बनाम",
      
      // Subscription
      manage_subscription: "सदस्यता प्रबंधित करें",
      manage_subscription_desc: "रद्द करें, भुगतान अपडेट करें, चालान डाउनलोड करें",
      
      // GuidePage
      back: "वापस",
      guide_title: "SmartBalloon गाइड",
      print_save_pdf: "प्रिंट / PDF सहेजें",
      go_to_dashboard: "डैशबोर्ड पर जाएं",
      table_of_contents: "विषय सूची",
      guide_intro: "परिचय",
      guide_upload: "1. ड्राइंग अपलोड करें",
      guide_views: "2. व्यू परिभाषित करें",
      guide_ai_detection: "3. AI पहचान",
      guide_markers: "4. मार्कर प्रबंधन",
      guide_cmm: "5. CMM आयात",
      guide_export: "6. निर्यात",
      guide_smartrevision: "7. SmartRevision",
      guide_projects: "प्रोजेक्ट प्रबंधन",
      guide_settings: "सेटिंग्स",
      guide_faq: "FAQ",
      guide_welcome_title: "SmartBalloon में आपका स्वागत है",
      guide_suggestion: "सुझाव:",
      
      // CMM Import Modal
      cmm_interpret_title: "रिपोर्ट कैसे व्याख्या करें?",
      cmm_interpret_desc: "आपने <strong>{count} CMM रिपोर्ट</strong> अपलोड की हैं। इन्हें कैसे व्याख्यायित किया जाए?",
      cmm_mode_manual_title: "मैं पार्ट्स मैन्युअल रूप से असाइन करता हूं",
      cmm_mode_manual_desc: "<strong>आप चुनें</strong> कौन सी रिपोर्ट किस पार्ट/सैंपल से मेल खाती है।",
      cmm_mode_manual_hint: "आप पार्ट्स का नाम बदल सकते हैं (जैसे: \"पार्ट A\", \"लॉट 123\", आदि)",
      cmm_mode_multi_title: "एकाधिक नमूने (स्वचालित)",
      cmm_mode_multi_desc: "प्रत्येक रिपोर्ट एक <strong>अलग पार्ट/सैंपल</strong> है, स्वचालित नंबरिंग।",
      cmm_mode_multi_hint: "रिपोर्ट 1 → P1, रिपोर्ट 2 → P2, आदि",
      cmm_mode_duplicate_title: "डुप्लिकेट रिपोर्ट",
      cmm_mode_duplicate_desc: "रिपोर्ट में <strong>एक ही पार्ट के माप</strong> हैं।",
      cmm_mode_duplicate_hint: "डुप्लिकेट आयामों को मैन्युअल चयन के लिए चिह्नित किया जाएगा।",
      cmm_continue: "जारी रखें",
      cmm_assign_title: "रिपोर्ट को पार्ट्स से असाइन करें",
      cmm_assign_desc: "प्रत्येक रिपोर्ट को एक नाम/नंबर असाइन करें। यह ISIR Excel कॉलम में पार्ट की पहचान करेगा।",
      cmm_assign_placeholder: "जैसे: P1, पार्ट A, लॉट 123",
      cmm_assign_tip: "छोटे नाम उपयोग करें जो Excel में कॉलम हेडर के रूप में दिखाई देंगे (जैसे P1, P2, लॉट A, आदि)",
      cmm_continue_import: "आयात जारी रखें",
      cmm_duplicate_title: "डुप्लिकेट आयाम - SB{id}",
      cmm_duplicate_desc: "यह आयाम कई रिपोर्ट में मौजूद है। चुनें कि कौन सा मान रखना है।",
      cmm_duplicate_count: "({current}/{total} डुप्लिकेट में से)",
      cmm_duplicate_existing: "मौजूदा मार्कर:",
      cmm_duplicate_current: "(वर्तमान: {value})",
      cmm_duplicate_prev: "← पीछे",
      cmm_duplicate_next: "आगे →",
      cmm_duplicate_confirm_all: "सभी की पुष्टि करें",
      
      // Manual Marker
      manual_marker: "मैन्युअल मार्कर",
      manual_marker_desc: "उन आयामों के लिए जो AI नहीं पढ़ सकता (घुमावदार, धुंधला), \"मैन्युअल मार्कर\" का उपयोग करें।",
      manual_marker_warning: "ज्यामितीय सहनशीलता के लिए भी मैन्युअल मार्कर का उपयोग करें (समतलता ⌂, समानांतरता //, बेलनाकारता ○, आदि)",
      manual_marker_insert: "मैन्युअल मार्कर डालें",
    }
  },
  ar: {
    translation: {
      // Common
      app_name: "SmartBalloon",
      save: "حفظ",
      cancel: "إلغاء",
      delete: "حذف",
      edit: "تعديل",
      close: "إغلاق",
      confirm: "تأكيد",
      loading: "جار التحميل...",
      error: "خطأ",
      success: "نجاح",
      
      // Auth
      login: "تسجيل الدخول",
      register: "التسجيل",
      logout: "تسجيل الخروج",
      email: "البريد الإلكتروني",
      password: "كلمة المرور",
      name: "الاسم",
      forgot_password: "نسيت كلمة المرور؟",
      no_account: "ليس لديك حساب؟",
      have_account: "لديك حساب بالفعل؟",
      login_success: "تم تسجيل الدخول بنجاح",
      register_success: "تم التسجيل بنجاح",
      created_by_experience: "تم إنشاؤه من خبرة",
      
      // Navigation
      dashboard: "لوحة التحكم",
      projects: "المشاريع",
      subscription: "الاشتراك",
      settings: "الإعدادات",
      
      // Projects
      new_project: "مشروع جديد",
      project_name: "اسم المشروع",
      project_description: "الوصف",
      create_project: "إنشاء مشروع",
      open_project: "فتح",
      delete_project: "حذف المشروع",
      no_projects: "لا توجد مشاريع. أنشئ مشروعك الأول!",
      
      // Workspace
      upload_drawing: "رفع الرسم",
      upload_logo: "رفع الشعار",
      drop_file: "اسحب الملف هنا أو انقر للتصفح",
      supported_formats: "المدعوم: PDF، PNG، JPG",
      
      // Tools
      select_tool: "تحديد",
      add_marker: "إضافة علامة",
      zoom_in: "تكبير",
      zoom_out: "تصغير",
      fit_to_screen: "ملاءمة الشاشة",
      
      // Markers
      marker: "علامة",
      markers: "علامات",
      description: "بُعد الرسم",
      nominal: "القيمة الاسمية",
      tolerance_plus: "التسامح العلوي",
      tolerance_minus: "التسامح السفلي",
      measured_value: "القيمة المقاسة",
      instrument: "الأداة",
      resolution: "الدقة",
      result: "النتيجة",
      ok: "موافق",
      not_ok: "غير موافق",
      
      // AI
      ai_detect: "الكشف بالذكاء الاصطناعي",
      ai_detecting: "جار الكشف...",
      ai_premium_only: "الكشف بالذكاء الاصطناعي متاح مع خطة AI Premium",
      ai_suggestions: "اقتراحات AI",
      accept_all: "قبول الكل",
      reject_all: "رفض الكل",
      
      // Export
      export: "تصدير",
      export_pdf: "تصدير PDF",
      export_excel: "تصدير ISIR Excel",
      exporting: "جار التصدير...",
      
      // Plans
      free_plan: "مجاني",
      pro_plan: "احترافي",
      ai_plan: "AI Premium",
      current_plan: "الخطة الحالية",
      upgrade: "ترقية",
      monthly: "شهرياً",
      features: "الميزات",
      max_markers: "الحد الأقصى للعلامات",
      unlimited_markers: "علامات غير محدودة",
      watermark: "تصدير مع علامة مائية",
      no_watermark: "تصدير كامل (بدون علامة مائية)",
      ai_detection: "كشف الأبعاد بالذكاء الاصطناعي",
      
      // Subscription cancelled
      subscription_cancelled: "تم إلغاء الاشتراك",
      subscription_cancelled_banner: "تم إلغاء اشتراكك",
      subscription_access_until: "ستستمر في الوصول حتى",
      subscription_days_remaining: "أيام متبقية",
      subscription_day_remaining: "يوم متبقي",
      subscription_expires_today: "ينتهي الاشتراك اليوم",
      subscription_reactivate: "إعادة تفعيل الاشتراك",
      subscription_cancelled_hint: "سيتم تخفيض خطتك إلى FREE بعد هذا التاريخ",
      
      // Messages
      project_created: "تم إنشاء المشروع",
      project_deleted: "تم حذف المشروع",
      changes_saved: "تم حفظ التغييرات",
      upload_success: "تم رفع الملف",
      export_started: "بدأ التصدير",
      marker_limit: "تم الوصول للحد الأقصى للعلامات. قم بالترقية إلى PRO للحصول على علامات غير محدودة.",
      
      // Welcome popup
      welcome_title: "مرحباً بك في SmartBalloon!",
      welcome_subtitle: "كل شيء جاهز! إليك كيفية البدء:",
      welcome_step1_title: "إنشاء مشروع جديد",
      welcome_step1_desc: "انقر على \"مشروع جديد\" للبدء",
      welcome_step2_title: "رفع الرسم الخاص بك",
      welcome_step2_desc: "قم بتحميل PDF أو صورة للتعليم عليها",
      welcome_step3_title: "ضع العلامات",
      welcome_step3_desc: "انقر على الأبعاد لإضافة العلامات",
      welcome_button: "فهمت، لنبدأ!",
      
      // Hero Section (Login Page)
      hero_title: "إدارة الجودة والرسومات الفنية في ثوانٍ",
      hero_subtitle: "من إنشاء البالونات إلى مقارنة المراجعات بالذكاء الاصطناعي",
      hero_step1: "رفع الرسم",
      hero_step2: "اكتشاف الأبعاد",
      hero_step3: "مقارنة المراجعات",
      
      // SmartBalloon Card
      smartballoon_title: "SmartBalloon",
      smartballoon_subtitle: "أنشئ البالونات تلقائياً، وأنشئ تقارير ISIR وأدر مراقبة الجودة",
      smartballoon_feature1: "بالونات آلية بالذكاء الاصطناعي",
      smartballoon_feature2: "إنشاء تقارير ISIR",
      smartballoon_feature3: "إدارة كاملة للأبعاد",
      
      // SmartRevision Card
      smartrevision_headline: "لا تثق فقط بمربع العنوان.",
      smartrevision_subheadline: "قارن بين مراجعتين واكتشف كل تغيير في ثوانٍ",
      smartrevision_title: "SmartRevision",
      smartrevision_subtitle: "حلل الاختلافات بين الرسومات وامنع أخطاء الإنتاج",
      smartrevision_feature1: "كشف الاختلافات تلقائياً",
      smartrevision_feature2: "تمييز التغييرات الحرجة",
      smartrevision_feature3: "يقلل أخطاء الإنتاج",
      
      hero_ai_premium: "متاح مع",
      guide: "دليل",
      
      // ComparePage - SmartRevision Workspace
      old_revision: "المراجعة القديمة",
      new_revision: "المراجعة الجديدة",
      all_comparisons: "جميع المقارنات",
      export_pdf: "تصدير PDF",
      differences: "الاختلافات",
      found: "وُجدت",
      vector: "متجه",
      opacity: "الشفافية",
      start_smartrevision: "بدء SmartRevision",
      legend: "وسيلة الإيضاح",
      legend_desc: "يتم تمييز الاختلافات بدوائر/أشكال بيضاوية ملونة للحفاظ على قابلية قراءة القيم الأصلية.",
      removed: "محذوف",
      added: "مضاف",
      modified: "معدّل",
      removed_desc: "موجود في {oldRev}، غائب في {newRev}",
      added_desc: "غائب في {oldRev}، موجود في {newRev}",
      summary: "ملخص:",
      differences_list: "قائمة الاختلافات",
      importance: "الأهمية:",
      importance_high: "عالية",
      importance_medium: "متوسطة",
      importance_low: "منخفضة",
      visual_diffs_detected: "تم اكتشاف اختلافات بصرية. التفاصيل الدلالية غير متوفرة.",
      upload_both_drawings: "ارفع كلا الرسمين",
      then_click: "ثم انقر على",
      green_added: "أخضر (مضاف)",
      red_removed: "أحمر (محذوف)",
      yellow_modified: "أصفر (معدّل)",
      diff_editor: "محرر الاختلافات",
      add_note: "إضافة ملاحظة",
      add_circle: "إضافة دائرة",
      undo: "تراجع",
      save_changes: "حفظ التغييرات",
      saved: "تم الحفظ",
      delete_circle: "حذف الدائرة",
      editor_instructions_line1: "انقر على دائرة/ملاحظة للتحديد • اسحب للنقل • DEL للحذف",
      editor_instructions_line2: "اسحب الزوايا لتغيير الحجم • مرر للتكبير • Ctrl+Z للتراجع",
      note_text_label: "نص الملاحظة:",
      loading_high_res: "جاري تحميل الصورة عالية الدقة...",
      loading_high_res_desc: "هذا يتيح أعلى جودة للرسومات الفنية",
      new_comparison_name: "مقارنة جديدة",
      guided_comparison_title: "تحتاج لمقارنة عرض واحد أو أكثر من الرسم فقط؟",
      guided_comparison_desc: "استخدم المقارنة الموجهة بالعرض",
      guided_comparison_hint: "استخدم هذا الوضع عندما يتم نقل العروض بين المراجعات",
      ai_credits_10: "يكلف التحليل 10 نقاط AI.",
      differences_found: "الاختلافات الموجودة:",
      zero_differences_title: "لم يتم العثور على أي اختلافات",
      zero_differences_message: "لم تجد المقارنة التلقائية أي اختلافات. هل أنت متأكد أن هذا نفس الرسم بمراجعات مختلفة؟",
      zero_differences_hint: "إذا كان الأمر كذلك، جرّب المقارنة الموجهة للعروض لتحديد مناطق معينة يدوياً للمقارنة.",
      try_guided_comparison: "جرّب المقارنة الموجهة",
      tutorial_upload_old: "رفع المراجعة القديمة",
      tutorial_upload_old_desc: "ارفع الرسم من المراجعة السابقة (PDF أو صورة).",
      tutorial_upload_new: "رفع المراجعة الجديدة",
      tutorial_upload_new_desc: "ارفع الرسم من المراجعة الجديدة للمقارنة.",
      tutorial_start_analysis: "بدء التحليل",
      tutorial_start_analysis_desc: "سيكتشف الذكاء الاصطناعي تلقائياً الاختلافات بين المراجعتين.",
      tutorial_open_editor: "فتح المحرر",
      tutorial_open_editor_desc: "تحقق من علامات الاختلاف وعدّلها في المحرر بملء الشاشة.",
      user_circle: "(مستخدم)",
      new_note: "ملاحظة جديدة",
      guided_results_title: "نتائج المقارنة الموجهة",
      views_analyzed: "عروض تم تحليلها",
      credits_consumed: "الرصيد المستهلك",
      no_differences: "لم يتم اكتشاف أي اختلافات.",
      
      // Dashboard & Folders
      new_folder: "مجلد جديد",
      folder_name: "اسم المجلد",
      folder_placeholder: "مثال: العملاء 2026",
      create_folder: "إنشاء مجلد",
      rename_project: "إعادة تسمية المشروع",
      move_to: "نقل إلى",
      move_to_root: "نقل إلى الجذر",
      no_description: "لا يوجد وصف",
      upload_company_logo: "ارفع شعار شركتك. سيتم استخدامه في تقارير ISIR.",
      logo_uploaded: "تم رفع شعار الشركة!",
      logo_deleted: "تم حذف الشعار",
      logo_only_images: "الصور فقط مسموحة",
      logo_too_large: "الشعار كبير جداً. الحد الأقصى 500KB",
      folder_created: "تم إنشاء المجلد",
      folder_deleted: "تم حذف المجلد",
      project_renamed: "تمت إعادة تسمية المشروع",
      project_moved: "تم نقل المشروع",
      confirm_delete_folder: "حذف هذا المجلد؟ سيتم نقل المشاريع إلى الجذر.",
      confirm_delete_project: "هل أنت متأكد من حذف هذا المشروع؟",
      
      // SmartRevision Page
      smartrevision_page_title: "SmartRevision",
      smartrevision_page_subtitle: "تحليل الاختلافات بين الرسومات",
      new_comparison: "مقارنة جديدة",
      comparison_name: "اسم المقارنة",
      comparison_description: "الوصف (اختياري)",
      create_comparison: "إنشاء مقارنة",
      no_comparisons: "لا توجد مقارنات",
      no_comparisons_desc: "أنشئ أول مقارنة لتحليل اختلافات الرسومات",
      upgrade_to_ai: "ترقية إلى خطة AI",
      starting_from: "ابتداءً من €99.99/شهر + ضريبة - 10 رصيد لكل تحليل",
      features_included: "الميزات المتضمنة:",
      visual_comparison: "مقارنة بصرية تلقائية",
      semantic_analysis: "تحليل دلالي بالذكاء الاصطناعي",
      pdf_export_report: "تصدير PDF مع تقرير مفصل",
      save_comparisons: "حفظ المقارنات",
      credits_label: "الرصيد:",
      open_comparison: "فتح",
      delete_comparison: "حذف",
      confirm_delete_comparison: "هل أنت متأكد من حذف هذه المقارنة؟",
      comparison_deleted: "تم حذف المقارنة",
      comparison_created: "تم إنشاء المقارنة",
      
      // SmartRevision Status & UI
      status_completed: "مكتمل",
      status_analyzing: "جار التحليل...",
      status_failed: "خطأ",
      status_pending: "قيد الانتظار",
      credits_used: "الرصيد المستخدم:",
      no_folder: "بدون مجلد",
      move_to_folder: "نقل إلى مجلد",
      remove_from_folder: "إزالة من المجلد",
      vs: "مقابل",
      
      // Subscription
      manage_subscription: "إدارة الاشتراك",
      manage_subscription_desc: "إلغاء، تحديث الدفع، تنزيل الفواتير",
      
      // GuidePage
      back: "رجوع",
      guide_title: "دليل SmartBalloon",
      print_save_pdf: "طباعة / حفظ PDF",
      go_to_dashboard: "انتقل إلى لوحة التحكم",
      table_of_contents: "جدول المحتويات",
      guide_intro: "مقدمة",
      guide_upload: "1. رفع الرسم",
      guide_views: "2. تحديد العروض",
      guide_ai_detection: "3. كشف AI",
      guide_markers: "4. إدارة العلامات",
      guide_cmm: "5. استيراد CMM",
      guide_export: "6. تصدير",
      guide_smartrevision: "7. SmartRevision",
      guide_projects: "إدارة المشاريع",
      guide_settings: "الإعدادات",
      guide_faq: "الأسئلة الشائعة",
      guide_welcome_title: "مرحباً بك في SmartBalloon",
      guide_suggestion: "اقتراح:",
      
      // CMM Import Modal
      cmm_interpret_title: "كيف تفسر التقارير؟",
      cmm_interpret_desc: "لقد قمت برفع <strong>{count} تقرير CMM</strong>. كيف يجب تفسيرها؟",
      cmm_mode_manual_title: "أعين القطع يدوياً",
      cmm_mode_manual_desc: "<strong>أنت تختار</strong> أي تقرير يتوافق مع أي قطعة/عينة.",
      cmm_mode_manual_hint: "يمكنك إعادة تسمية القطع (مثل: \"قطعة A\"، \"الدفعة 123\"، إلخ)",
      cmm_mode_multi_title: "عينات متعددة (تلقائي)",
      cmm_mode_multi_desc: "كل تقرير هو <strong>قطعة/عينة مختلفة</strong>، ترقيم تلقائي.",
      cmm_mode_multi_hint: "التقرير 1 → P1، التقرير 2 → P2، إلخ",
      cmm_mode_duplicate_title: "تقارير مكررة",
      cmm_mode_duplicate_desc: "التقارير تحتوي على <strong>قياسات نفس القطعة</strong>.",
      cmm_mode_duplicate_hint: "سيتم تحديد الأبعاد المكررة للاختيار اليدوي.",
      cmm_continue: "متابعة",
      cmm_assign_title: "تعيين التقارير للقطع",
      cmm_assign_desc: "عيّن اسم/رقم لكل تقرير. سيحدد هذا القطعة في أعمدة ISIR Excel.",
      cmm_assign_placeholder: "مثال: P1، قطعة A، الدفعة 123",
      cmm_assign_tip: "استخدم أسماء قصيرة ستظهر كعناوين أعمدة في Excel (مثل P1، P2، الدفعة A، إلخ)",
      cmm_continue_import: "متابعة مع الاستيراد",
      cmm_duplicate_title: "بُعد مكرر - SB{id}",
      cmm_duplicate_desc: "هذا البُعد موجود في تقارير متعددة. اختر القيمة التي تريد الاحتفاظ بها.",
      cmm_duplicate_count: "({current} من {total} مكررات)",
      cmm_duplicate_existing: "علامة موجودة:",
      cmm_duplicate_current: "(الحالي: {value})",
      cmm_duplicate_prev: "← رجوع",
      cmm_duplicate_next: "التالي →",
      cmm_duplicate_confirm_all: "تأكيد الكل",
      
      // Manual Marker
      manual_marker: "علامة يدوية",
      manual_marker_desc: "للأبعاد التي لا يستطيع AI قراءتها (مدارة، ضبابية)، استخدم \"علامة يدوية\".",
      manual_marker_warning: "استخدم أيضاً العلامة اليدوية للتفاوتات الهندسية (التسطيح ⌂، التوازي //، الأسطوانية ○، إلخ)",
      manual_marker_insert: "إدراج علامة يدوية",
    }
  }
};
